import { RecursiveStringifyEnums } from '@/testData/buildDistro';
import {
    AppPlatform,
    AppStoreType,
    ReleaseStatus,
    ReleaseStep,
    ReleaseStepKickoffData,
    ReleaseStepStatus,
    ReleaseStepType,
    ReleaseTimelinePhase,
} from '@/types';
import { featuresStep } from '@/testData/featureItems';
import { generateTranslationsDemoData } from '@/testData/translations';
import { topNewStabilityIssues, topStabilityIssues } from '@/testData/appHome';

const translationData = generateTranslationsDemoData();

const generateCommonTestData = (platform: AppPlatform) => {
    if (platform === AppPlatform.Ios) {
        return {
            releaseBranch: 'release-1.0.0',
            workingBranch: 'development',
            isStaticReleaseBranch: false,
            canBeSubmitted: true,
            doesBranchExist: true,
            appStoreReleaseSettings: {
                exportComplianceInfoUsesEncryption: false,
                phasedRelease: true,
                releaseMethod: 'releaseMethodManual',
                resetSummaryRating: false,
            },
            appStoreAvailableBuilds: [
                {
                    isRecentBuild: true,
                    appStoreBuild: {
                        buildNumber: '298',
                        id: '475bf507-c3c4-443f-9845-932f16748ec7',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T18:07:07-07:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',
                        artifacts: [],
                        buildFinishedAt: '2022-03-21T17:32:25Z',
                        buildHash: 'zcebLLhLwk8m-GonPSg84G6omXw=',
                        buildIdentifier: '298',
                        buildStartedAt: '2022-03-21T17:23:53Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/abc',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: true,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: null,
                },
                {
                    isRecentBuild: false,
                    appStoreBuild: {
                        buildNumber: '297',
                        id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T12:31:21-07:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',
                        buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                        buildIdentifier: '297',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-15T19:17:48Z',
                        buildFinishedAt: '2022-03-15T19:28:41Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: true,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: 'manualRunwaySelection',
                },
                {
                    isRecentBuild: false,
                    appStoreBuild: {
                        buildNumber: '296',
                        id: 'ac1fa4d1-8664-4679-ae19-9842afaff37e',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T11:50:03-07:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',

                        buildHash: '0qVMy0jBTbwzL5k67ZzU092K-wA=',
                        buildIdentifier: '296',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-15T18:35:29Z',
                        buildFinishedAt: '2022-03-15T18:46:11Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: null,
                },
                {
                    isRecentBuild: false,
                    appStoreBuild: {
                        buildNumber: '290',
                        id: 'bb1a73c7-7645-499d-852a-7a6a96c7de30',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-11T12:08:29-08:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',

                        buildHash: 'cYAkkfz3H8wQ_0fBrtp05sJ6uMA=',
                        buildIdentifier: '290',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-11T19:55:17Z',
                        buildFinishedAt: '2022-03-11T20:05:46Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: null,
                },
                {
                    isRecentBuild: false,
                    appStoreBuild: {
                        buildNumber: '289',
                        id: '7e8abdd7-22d5-4194-a958-d03e6fed233f',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-10T08:20:05-08:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',

                        buildHash: '2LLiuHxPPvmLOnRjj8SzN86Gx54=',
                        buildIdentifier: '289',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-10T16:06:14Z',
                        buildFinishedAt: '2022-03-10T16:16:53Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0facaf1063bfa427b4bb1b5dba5b35d662c3bf45',
                        commitMessage:
                            'Merge pull request #118 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: null,
                },
                {
                    isRecentBuild: false,
                    appStoreBuild: {
                        buildNumber: '284',
                        id: 'f5f20fd6-e19c-46b9-b1ab-0ba3fda93cae',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-03T10:09:08-08:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',

                        buildHash: 'ux-OXdNnKuSGcQGoUxWVzOmXmBk=',
                        buildIdentifier: '284',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-03T17:55:15Z',
                        buildFinishedAt: '2022-03-03T18:05:50Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0facaf1063bfa427b4bb1b5dba5b35d662c3bf45',
                        commitMessage:
                            'Merge pull request #118 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: null,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: null,
                        topStabilityIssues: [],
                        topNewStabilityIssues: [],
                        topStabilityIssuesNonFatal: [],
                        topNewStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: null,
                },
            ],
            additionalAppStoreSelectedBuilds: null,
            appStoreSelectedBuilds: [
                {
                    isRecentBuild: true,
                    appStoreBuild: {
                        buildNumber: '297',
                        id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                        integrationId: 'apple',
                        isProcessed: true,

                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T12:31:21-07:00',
                    },
                    associatedCIBuild: {
                        commitUrl: '',
                        buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                        buildIdentifier: '297',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        buildStartedAt: '2022-03-15T19:17:48Z',
                        buildFinishedAt: '2022-03-15T19:28:41Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        commitAuthor: null,
                    },
                    isCurrentlySelected: true,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: {
                        version: '3.97.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: 99.5,
                        userStability: 99.7,
                        sessionAdoption: 4.5,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: 'Production',
                        topNewStabilityIssues: topNewStabilityIssues(platform),
                        topStabilityIssues: topStabilityIssues(platform),
                        topNewStabilityIssuesNonFatal: [],
                        topStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: 'manualRunwaySelection',
                },
            ],
            latestSuccessfulProdBuild: null,
            latestPassingRegressionTestBuild: null,
            selectedBetaBuild: null,
            prodBuild: null,
            selectedStagingBuild: {
                ciBuild: {
                    commitUrl: '',
                    buildHash: 'zcebLLhLwk8m-GonPSg84G6omXw=',
                    buildIdentifier: '298',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/123',
                    buildStartedAt: '2022-03-21T17:23:53Z',
                    buildFinishedAt: '2022-03-21T17:32:25Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                    commitMessage:
                        'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`.',
                    commitAuthor: 'runway-github[bot]',
                    artifacts: [
                        {
                            version: 'X.X.X',
                            workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            artifactId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            fileName: 'app.dSYM.zip',
                            size: 16 * 1_024 * 1_024,
                            downloadUrl: 'https://demo.runway.team',
                            appStoreInfos: null,
                            dsymUploadInfo: null,
                        },
                        {
                            version: 'X.X.X',
                            workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            artifactId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            fileName: 'app.ipa',
                            size: 139 * 1_024 * 1_024,
                            downloadUrl: 'https://demo.runway.team',
                            appStoreInfos: null,
                            dsymUploadInfo: null,
                        },
                    ],
                },
                associatedAppStoreBuild: null,
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
            latestSuccessfulBuild: {
                ciBuild: {
                    commitUrl: '',
                    buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                    buildIdentifier: '297',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/123',
                    buildStartedAt: '2022-03-15T19:17:48Z',
                    buildFinishedAt: '2022-03-15T19:28:41Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                    commitMessage:
                        'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                    commitAuthor: 'runway-github[bot]',
                    artifacts: [
                        {
                            version: 'X.X.X',
                            workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            artifactId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            fileName: 'app.dSYM.zip',
                            size: 16 * 1_024 * 1_024,
                            downloadUrl: 'https://demo.runway.team',
                            appStoreInfos: null,
                            dsymUploadInfo: null,
                        },
                        {
                            version: 'X.X.X',
                            workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            artifactId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                            fileName: 'app.ipa',
                            size: 139 * 1_024 * 1_024,
                            downloadUrl: 'https://demo.runway.team',
                            appStoreInfos: null,
                            dsymUploadInfo: null,
                        },
                    ],
                },
                associatedAppStoreBuild: {
                    buildNumber: '297',
                    id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                    integrationId: 'apple',
                    isProcessed: true,

                    type: 'ios-binary',
                    uploadedAt: '2022-03-15T12:31:21-07:00',
                },
                isSelectedBuild: false,
                selectedReason: 'autoRunwaySelection',
            },
        };
    } else if (platform === AppPlatform.Android) {
        return {
            doesBranchExist: true,
            releaseBranch: 'release-1.25.0',
            workingBranch: 'develop',
            isStaticReleaseBranch: false,
            canBeSubmitted: false,
            appStoreAvailableBuilds: [
                {
                    appStoreBuild: {
                        buildNumber: '27500',
                        id: '27500',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T18:11:14.055381Z',
                    },
                    associatedCIBuild: {
                        buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                        buildIdentifier: '275',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io',
                        buildStartedAt: '2022-03-15T18:06:21Z',
                        buildFinishedAt: '2022-03-15T18:09:36Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitMessage:
                            'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        commitAuthor: null,
                        commitUrl: '',
                    },
                    isCurrentlySelected: true,
                    isNewestAppStoreBuild: true,
                    stabilityInfo: null,
                    selectedBuildReason: 'autoRunwaySelection',
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '27401',
                        id: '27401',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T16:49:19.271479Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '27400',
                        id: '27400',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T16:49:19.271479Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '27100',
                        id: '27100',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T15:53:26.217791Z',
                    },
                    associatedCIBuild: {
                        buildHash: 'v_LYY2Q_tHP__uFMuoahvSvrjbs=',
                        buildIdentifier: '271',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io',
                        buildStartedAt: '2022-03-15T15:50:06Z',
                        buildFinishedAt: '2022-03-15T15:53:31Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitMessage:
                            'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        commitAuthor: null,
                        commitUrl: '',
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '26600',
                        id: '26600',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-02-22T15:10:44.431772-06:00',
                    },
                    associatedCIBuild: {
                        buildHash: 'xIF7XbFDz_ILtKZjP3TOnVythwo=',
                        buildIdentifier: '266',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io',
                        buildStartedAt: '2022-02-22T21:05:24Z',
                        buildFinishedAt: '2022-02-22T21:09:21Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitMessage:
                            'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        commitAuthor: null,
                        commitUrl: '',
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '26300',
                        id: '26300',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-02-14T18:29:27.228176572Z',
                    },
                    associatedCIBuild: {
                        buildHash: 'EoC1sXC38yCv2FysjX3xoT8joUE=',
                        buildIdentifier: '263',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io',
                        buildStartedAt: '2022-02-14T18:26:48Z',
                        buildFinishedAt: '2022-02-14T18:29:57Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '2a9abf9fb4eb2355dfd1600b622ea4f63ee4405d',
                        commitMessage:
                            'Bumping version to 1.24.0 (#40)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        commitAuthor: null,
                        commitUrl: '',
                    },
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '26200',
                        id: '26200',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-02-08T23:07:41.964490856Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '25900',
                        id: '25900',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-02-02T00:09:40.832635316Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '25600',
                        id: '25600',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-02-01T00:13:00.647973251Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '25300',
                        id: '25300',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-31T22:16:22.361822282Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '24800',
                        id: '24800',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-31T15:07:17.977167-05:00',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '24300',
                        id: '24300',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-27T22:40:21.311073832Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '23801',
                        id: '23801',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-25T21:19:51.133775092Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '23800',
                        id: '23800',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-25T21:19:51.133775092Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '23701',
                        id: '23701',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-25T18:53:49.573341077Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '23601',
                        id: '23601',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-25T18:03:55.275948131Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '23600',
                        id: '23600',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-25T18:03:55.275948131Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '22800',
                        id: '22800',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-01-20T16:23:27.978286724Z',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
                {
                    appStoreBuild: {
                        buildNumber: '123',
                        id: '123',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-apk',
                        uploadedAt: '2021-07-16T14:30:39.569438829-04:00',
                    },
                    associatedCIBuild: null,
                    isCurrentlySelected: false,
                    isNewestAppStoreBuild: false,
                    stabilityInfo: null,
                    selectedBuildReason: null,
                    isRecentBuild: false,
                },
            ],
            additionalAppStoreSelectedBuilds: ['27100', '26200'],
            appStoreSelectedBuilds: [
                {
                    appStoreBuild: {
                        buildNumber: '27500',
                        id: '27500',
                        integrationId: 'google',
                        isProcessed: true,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T18:11:14.055381Z',
                    },
                    associatedCIBuild: {
                        buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                        buildIdentifier: '275',
                        integrationId: 'bitrise',
                        buildUrl: 'https://app.bitrise.io',
                        buildStartedAt: '2022-03-15T18:06:21Z',
                        buildFinishedAt: '2022-03-15T18:09:36Z',
                        buildStatus: 'success',
                        providerBuildStatusString: 'Success',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitMessage:
                            'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        commitAuthor: null,
                        commitUrl: '',
                    },
                    isCurrentlySelected: true,
                    isNewestAppStoreBuild: true,
                    stabilityInfo: {
                        version: '1.25.0',
                        buildIdentifier: '',
                        appStoreAppIdentifier: '',
                        integrationId: 'sentry',
                        sessionStability: null,
                        userStability: null,
                        sessionAdoption: 4.5,
                        userAdoption: null,
                        adoptionPeriodString: null,
                        url: null,
                        environmentName: 'Production',
                        topNewStabilityIssues: topNewStabilityIssues(platform),
                        topStabilityIssues: topStabilityIssues(platform),
                        topNewStabilityIssuesNonFatal: [],
                        topStabilityIssuesNonFatal: [],
                    },
                    selectedBuildReason: 'autoRunwaySelection',
                    isRecentBuild: false,
                },
            ],
            latestSuccessfulProdBuild: null,
            latestPassingRegressionTestBuild: null,
            selectedBetaBuild: null,
            prodBuild: null,
            selectedStagingBuild: {
                ciBuild: {
                    buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                    buildIdentifier: '275',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io',
                    buildStartedAt: '2022-03-15T18:06:21Z',
                    buildFinishedAt: '2022-03-15T18:09:36Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                    commitMessage:
                        'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                    commitAuthor: 'runwayhelperdev[bot]',
                    artifacts: [],
                    commitUrl: '',
                },
                associatedAppStoreBuild: {
                    buildNumber: '27500',
                    id: '27500',
                    integrationId: 'google-beta',
                    isProcessed: true,
                    type: 'android-aab',
                    uploadedAt: '2022-03-15T18:11:14.055381Z',
                },
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
            latestSuccessfulBuild: {
                ciBuild: {
                    buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                    buildIdentifier: '275',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io',
                    buildStartedAt: '2022-03-15T18:06:21Z',
                    buildFinishedAt: '2022-03-15T18:09:36Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                    commitMessage:
                        'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                    commitAuthor: 'runwayhelperdev[bot]',
                    artifacts: [],
                    commitUrl: '',
                },
                associatedAppStoreBuild: {
                    buildNumber: '27500',
                    id: '27500',
                    integrationId: 'google-beta',
                    isProcessed: true,
                    type: 'android-aab',
                    uploadedAt: '2022-03-15T18:11:14.055381Z',
                },
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
        };
    } else {
        return {
            doesBranchExist: true,
            releaseBranch: 'release-codepush-1.3.0',
            workingBranch: 'develop',
            isStaticReleaseBranch: false,
            canBeSubmitted: false,
            appStoreAvailableBuilds: [],
            additionalAppStoreSelectedBuilds: null,
            appStoreSelectedBuilds: [],
            latestSuccessfulProdBuild: null,
            latestPassingRegressionTestBuild: null,
            selectedBetaBuild: null,
            prodBuild: null,
            selectedStagingBuild: {
                ciBuild: {
                    buildHash: 'fIYLHm7c9r5yxKacHK9H41G7eG8=',
                    buildIdentifier: '15',
                    integrationId: 'github-ci',
                    buildUrl: 'https://github.com/demo/fake-react-native/actions/runs/12345678',
                    buildStartedAt: '2022-02-22T15:17:12Z',
                    buildFinishedAt: '2022-02-22T15:19:47Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                    commitMessage:
                        'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                    commitAuthor: 'Amelia Earhart',
                    artifacts: [],
                    commitUrl: '',
                },
                associatedAppStoreBuild: null,
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
            latestSuccessfulBuild: {
                ciBuild: {
                    buildHash: 'fIYLHm7c9r5yxKacHK9H41G7eG8=',
                    buildIdentifier: '15',
                    integrationId: 'github-ci',
                    buildUrl: 'https://github.com/demo/fake-react-native/actions/runs/12345678',
                    buildStartedAt: '2022-02-22T15:17:12Z',
                    buildFinishedAt: '2022-02-22T15:19:47Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                    commitMessage:
                        'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                    commitAuthor: 'Amelia Earhart',
                    artifacts: [],
                    commitUrl: '',
                },
                associatedAppStoreBuild: null,
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
        };
    }
};

const generateReleaseStepTakeoffData = (platform: AppPlatform) => {
    const data =
        platform === AppPlatform.Android ?
            {
                autoStagedRolloutAutomationId: null,
                appStoreType: 'GooglePlay',
                platform: 'android',
                appStoreData: {
                    phasedRelease: {
                        isManuallyAcceleratedPhasedRollout: false,
                        isRunwayAcceleratedRollout: false,
                        isRunwayPaused: false,
                        state: 'draft',
                        userFraction: 0,
                        phasedReleasePercent: 0,
                        dayNumber: 0,
                        isOnBlackoutPeriod: false,
                        isSuperseded: false,
                    },
                    state: 'draft',
                },
                appStoreUrl: 'https://play.google.com/store/apps/details?id=com.runway.example',
                storeUrl: 'https://play.google.com/console',
                tagData: {
                    codeDiffUrl: 'https://github.com',
                    expectedReleaseTagName: 'v1.25.0',
                    releaseTag: null,
                    releaseTagState: 'notTaggable',
                },
                isReleaseTagged: false,
                phasedReleaseHasBeenSupersededByNewRelease: false,
                lastCompletedRelease: null,
                ...generateCommonTestData(platform),
            }
        : platform === AppPlatform.Ios ?
            {
                autoStagedRolloutAutomationId: null,
                appStoreType: 'AppStoreConnect',
                platform: 'ios',
                appStoreData: {
                    customProductPages: [
                        {
                            ascLink:
                                'https://appstoreconnect.apple.com/apps/1234/distribution/productpages/92904ee5-8644-4d83-b585-e56dfab21062',
                            firstVersionLocalization: {
                                appPreviewSets: [],
                                id: 'e389095f-a40a-4ee3-873b-194456e096d9',
                                locale: 'en-US',
                                promotionalText: '',
                                screenshotSets: [
                                    {
                                        id: '57cd0dd4-70e4-45c6-b722-95971b96688e',
                                        screenshotDisplayType: 'APP_IPHONE_55',
                                        screenshots: [
                                            {
                                                height: 2208,
                                                id: '',
                                                uploadError: null,
                                                url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                width: 1242,
                                            },
                                            {
                                                height: 2208,
                                                id: '',
                                                uploadError: null,
                                                url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                width: 1242,
                                            },
                                        ],
                                    },
                                    {
                                        id: '2d0b079f-06c5-4df0-8ea8-d5b0269dd0db',
                                        screenshotDisplayType: 'APP_IPHONE_65',
                                        screenshots: [
                                            {
                                                height: 2208,
                                                id: '',
                                                uploadError: null,
                                                url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                width: 1242,
                                            },
                                            {
                                                height: 2208,
                                                id: '',
                                                uploadError: null,
                                                url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                width: 1242,
                                            },
                                        ],
                                    },
                                ],
                            },
                            id: '92904ee5-8644-4d83-b585-e56dfab21062',
                            name: 'Another product page',
                            url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=92904ee5-8644-4d83-b585-e56dfab21062',
                            versions: [
                                {
                                    id: '21dd3774-cee0-4b76-97bf-6736f9ee1ed1',
                                    state: 'APPROVED',
                                    version: '1',
                                },
                            ],
                            visible: true,
                        },
                    ],
                    inAppEvents: [
                        {
                            ascLink: 'https://appstoreconnect.apple.com/apps/595068603/distribution/events/6502416798',
                            badge: 'LIVE_EVENT',
                            eventState: 'DRAFT',
                            id: '6502416798',
                            longDescription: 'Join us for a live stream demo...',
                            previewImages: [
                                {
                                    height: 1080,
                                    type: 'EVENT_CARD',
                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/eVpKWMMqHdOq-dYA8MYZOw/192x108bb.jpg',
                                    width: 1920,
                                },
                                {
                                    height: 1920,
                                    type: 'EVENT_DETAILS_PAGE',
                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/t-pvtnJkPMCLjjkRyB5BGA/108x192bb.jpg',
                                    width: 1080,
                                },
                            ],
                            primaryLocale: 'en-US',
                            referenceName: 'New Live Stream Event',
                            shortDescription: 'Live stream demo of New',
                            territorySchedules: [
                                {
                                    eventEnd: '2024-05-13T20:00:00Z',
                                    eventStart: '2024-05-13T18:00:00Z',
                                    publishStart: '2024-05-09T22:00:00Z',
                                    territories: [],
                                },
                            ],
                        },
                    ],
                    relevantReviewSubmission: {
                        appStoreVersionForReviewId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                        id: 'b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                        buildSubmissionStatus: 'UNBLOCKED',
                        reviewSubmissionASCLink:
                            'https://appstoreconnect.apple.com/apps/595068603/distribution/reviewsubmissions/details/b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                        reviewSubmissionItems: [
                            {
                                id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDZ8ODY1NjczMDQ1',
                                item: null,
                                itemId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                                state: 'READY_FOR_REVIEW',
                                type: 'appStoreVersions',
                            },
                            {
                                id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDV8YjFiYjY4MTctZjAwYi00MTQxLTlhMDUtNTdhMzk5ZjQ3YTU0',
                                item: {
                                    ascLink:
                                        'https://appstoreconnect.apple.com/apps/595068603/distribution/productpages/321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                    firstVersionLocalization: {
                                        appPreviewSets: [],
                                        id: '8a4cd3d8-d561-4e28-8d7d-bc17ad7f2640',
                                        locale: 'en-US',
                                        promotionalText: '',
                                        screenshotSets: [
                                            {
                                                id: '57cd0dd4-70e4-45c6-b722-95971b96688e',
                                                screenshotDisplayType: 'APP_IPHONE_55',
                                                screenshots: [
                                                    {
                                                        height: 2208,
                                                        id: '',
                                                        uploadError: null,
                                                        url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                        width: 1242,
                                                    },
                                                    {
                                                        height: 2208,
                                                        id: '',
                                                        uploadError: null,
                                                        url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                        width: 1242,
                                                    },
                                                ],
                                            },
                                            {
                                                id: '2d0b079f-06c5-4df0-8ea8-d5b0269dd0db',
                                                screenshotDisplayType: 'APP_IPHONE_65',
                                                screenshots: [
                                                    {
                                                        height: 2208,
                                                        id: '',
                                                        uploadError: null,
                                                        url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                        width: 1242,
                                                    },
                                                    {
                                                        height: 2208,
                                                        id: '',
                                                        uploadError: null,
                                                        url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                        width: 1242,
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    id: '321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                    name: 'New Product Page',
                                    url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                    versions: [
                                        {
                                            id: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                                            state: 'READY_FOR_REVIEW',
                                            version: '1',
                                        },
                                    ],
                                    visible: true,
                                },
                                itemId: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                                state: 'READY_FOR_REVIEW',
                                type: 'appCustomProductPageVersions',
                            },
                        ],
                        state: 'READY_FOR_REVIEW',
                    },
                    reviewDetail: {
                        contactEmail: 'aearhart@demo.com',
                        contactFirstName: 'Amelia',
                        contactLastName: 'Earhart',
                        contactPhone: '+(123)456-7891',
                        demoAccountName: null,
                        demoAccountPassword: null,
                        demoAccountRequired: false,
                        notes: '',
                        id: '1234',
                        reviewAttachments: [],
                    },
                    versionReviewSubmissionItem: {
                        earliestReleaseDate: null,
                        id: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                        releaseType: 'MANUAL',
                        state: 'READY_FOR_REVIEW',
                    },
                    phasedRelease: {
                        dayNumber: 0,
                        isManuallyAcceleratedPhasedRollout: false,
                        isRunwayAcceleratedRollout: false,
                        isRunwayPaused: false,
                        startDate: null,
                        state: 'INACTIVE',
                        userFraction: 0,
                        blackoutEndsAt: '2024-05-10T13:33:32.988339868-07:00',
                        changedByAutomation: null,
                        completedAt: null,
                        isOnBlackoutPeriod: false,
                        phasedReleasePercent: 0,
                        isSuperseded: false,
                    },
                },
                appStoreUrl: 'https://apps.apple.com',
                storeUrl: 'https://appstoreconnect.apple.com',
                tagData: {
                    codeDiffUrl: 'https://github.com/demo/demo-ios/compare',
                    expectedReleaseTagName: 'v3.97.0',
                    releaseTag: null,
                    releaseTagState: 'notTaggable',
                },
                isReleaseTagged: false,
                phasedReleaseHasBeenSupersededByNewRelease: false,
                lastCompletedRelease: null,
                ...generateCommonTestData(platform),
            }
        :   null;
    return data;
};

const generateReleaseStepSubmissionData = (platform: AppPlatform) => {
    if (platform === AppPlatform.Ios) {
        return {
            platform: 'ios',
            autoStagedRolloutAutomationId: null,
            latestReleasePhasedRelease: null,
            latestReleaseVersion: null,
            appStoreData: {
                customProductPages: [
                    {
                        ascLink:
                            'https://appstoreconnect.apple.com/apps/1234/distribution/productpages/92904ee5-8644-4d83-b585-e56dfab21062',
                        firstVersionLocalization: {
                            appPreviewSets: [],
                            id: 'e389095f-a40a-4ee3-873b-194456e096d9',
                            locale: 'en-US',
                            promotionalText: '',
                            screenshotSets: [
                                {
                                    id: '57cd0dd4-70e4-45c6-b722-95971b96688e',
                                    screenshotDisplayType: 'APP_IPHONE_55',
                                    screenshots: [
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                            width: 1242,
                                        },
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                            width: 1242,
                                        },
                                    ],
                                },
                                {
                                    id: '2d0b079f-06c5-4df0-8ea8-d5b0269dd0db',
                                    screenshotDisplayType: 'APP_IPHONE_65',
                                    screenshots: [
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                            width: 1242,
                                        },
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                            width: 1242,
                                        },
                                    ],
                                },
                            ],
                        },
                        id: '92904ee5-8644-4d83-b585-e56dfab21062',
                        name: 'Another product page',
                        url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=92904ee5-8644-4d83-b585-e56dfab21062',
                        versions: [
                            {
                                id: '21dd3774-cee0-4b76-97bf-6736f9ee1ed1',
                                state: 'APPROVED',
                                version: '1',
                            },
                        ],
                        visible: true,
                    },
                ],
                inAppEvents: [
                    {
                        ascLink: 'https://appstoreconnect.apple.com/apps/595068603/distribution/events/6502416798',
                        badge: 'LIVE_EVENT',
                        eventState: 'DRAFT',
                        id: '6502416798',
                        longDescription: 'Join us for a live stream demo...',
                        previewImages: [
                            {
                                height: 1080,
                                type: 'EVENT_CARD',
                                url: 'https://is1-ssl.mzstatic.com/image/thumb/eVpKWMMqHdOq-dYA8MYZOw/192x108bb.jpg',
                                width: 1920,
                            },
                            {
                                height: 1920,
                                type: 'EVENT_DETAILS_PAGE',
                                url: 'https://is1-ssl.mzstatic.com/image/thumb/t-pvtnJkPMCLjjkRyB5BGA/108x192bb.jpg',
                                width: 1080,
                            },
                        ],
                        primaryLocale: 'en-US',
                        referenceName: 'New Live Stream Event',
                        shortDescription: 'Live stream demo of New',
                        territorySchedules: [
                            {
                                eventEnd: '2024-05-13T20:00:00Z',
                                eventStart: '2024-05-13T18:00:00Z',
                                publishStart: '2024-05-09T22:00:00Z',
                                territories: [
                                    'AFG',
                                    'AGO',
                                    'AIA',
                                    'ALB',
                                    'ARE',
                                    'ARG',
                                    'ARM',
                                    'ATG',
                                    'AUS',
                                    'AUT',
                                    'AZE',
                                    'BEL',
                                    'BEN',
                                    'BFA',
                                    'BGR',
                                    'BHR',
                                    'BHS',
                                    'BIH',
                                    'BLR',
                                    'BLZ',
                                    'BMU',
                                    'BOL',
                                    'BRA',
                                    'BRB',
                                    'BRN',
                                    'BTN',
                                    'BWA',
                                    'CAN',
                                    'CHE',
                                    'CHL',
                                    'CHN',
                                    'CIV',
                                    'CMR',
                                    'COD',
                                    'COG',
                                    'COL',
                                    'CPV',
                                    'CRI',
                                    'CYM',
                                    'CYP',
                                    'CZE',
                                    'DEU',
                                    'DMA',
                                    'DNK',
                                    'DOM',
                                    'DZA',
                                    'ECU',
                                    'EGY',
                                    'ESP',
                                    'EST',
                                    'FIN',
                                    'FJI',
                                    'FRA',
                                    'FSM',
                                    'GAB',
                                    'GBR',
                                    'GEO',
                                    'GHA',
                                    'GMB',
                                    'GNB',
                                    'GRC',
                                    'GRD',
                                    'GTM',
                                    'GUY',
                                    'HKG',
                                    'HND',
                                    'HRV',
                                    'HUN',
                                    'IDN',
                                    'IND',
                                    'IRL',
                                    'IRQ',
                                    'ISL',
                                    'ISR',
                                    'ITA',
                                    'JAM',
                                    'JOR',
                                    'JPN',
                                    'KAZ',
                                    'KEN',
                                    'KGZ',
                                    'KHM',
                                    'KNA',
                                    'KOR',
                                    'KWT',
                                    'LAO',
                                    'LBN',
                                    'LBR',
                                    'LBY',
                                    'LCA',
                                    'LKA',
                                    'LTU',
                                    'LUX',
                                    'LVA',
                                    'MAC',
                                    'MAR',
                                    'MDA',
                                    'MDG',
                                    'MDV',
                                    'MEX',
                                    'MKD',
                                    'MLI',
                                    'MLT',
                                    'MMR',
                                    'MNE',
                                    'MNG',
                                    'MOZ',
                                    'MRT',
                                    'MSR',
                                    'MUS',
                                    'MWI',
                                    'MYS',
                                    'NAM',
                                    'NER',
                                    'NGA',
                                    'NIC',
                                    'NLD',
                                    'NOR',
                                    'NPL',
                                    'NRU',
                                    'NZL',
                                    'OMN',
                                    'PAK',
                                    'PAN',
                                    'PER',
                                    'PHL',
                                    'PLW',
                                    'PNG',
                                    'POL',
                                    'PRT',
                                    'PRY',
                                    'QAT',
                                    'ROU',
                                    'RUS',
                                    'RWA',
                                    'SAU',
                                    'SEN',
                                    'SGP',
                                    'SLB',
                                    'SLE',
                                    'SLV',
                                    'SRB',
                                    'STP',
                                    'SUR',
                                    'SVK',
                                    'SVN',
                                    'SWE',
                                    'SWZ',
                                    'SYC',
                                    'TCA',
                                    'TCD',
                                    'THA',
                                    'TJK',
                                    'TKM',
                                    'TON',
                                    'TTO',
                                    'TUN',
                                    'TUR',
                                    'TWN',
                                    'TZA',
                                    'UGA',
                                    'UKR',
                                    'URY',
                                    'USA',
                                    'UZB',
                                    'VCT',
                                    'VEN',
                                    'VGB',
                                    'VNM',
                                    'VUT',
                                    'XKS',
                                    'YEM',
                                    'ZAF',
                                    'ZMB',
                                    'ZWE',
                                ],
                            },
                        ],
                    },
                ],
                integrationId: 'apple',
                relevantReviewSubmission: {
                    appStoreVersionForReviewId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                    id: 'b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                    buildSubmissionStatus: 'UNBLOCKED',
                    reviewSubmissionASCLink:
                        'https://appstoreconnect.apple.com/apps/595068603/distribution/reviewsubmissions/details/b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                    reviewSubmissionItems: [
                        {
                            id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDZ8ODY1NjczMDQ1',
                            item: null,
                            itemId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                            state: 'READY_FOR_REVIEW',
                            type: 'appStoreVersions',
                        },
                        {
                            id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDV8YjFiYjY4MTctZjAwYi00MTQxLTlhMDUtNTdhMzk5ZjQ3YTU0',
                            item: {
                                ascLink:
                                    'https://appstoreconnect.apple.com/apps/595068603/distribution/productpages/321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                firstVersionLocalization: {
                                    appPreviewSets: [],
                                    id: '8a4cd3d8-d561-4e28-8d7d-bc17ad7f2640',
                                    locale: 'en-US',
                                    promotionalText: '',
                                    screenshotSets: [
                                        {
                                            id: '57cd0dd4-70e4-45c6-b722-95971b96688e',
                                            screenshotDisplayType: 'APP_IPHONE_55',
                                            screenshots: [
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                    width: 1242,
                                                },
                                            ],
                                        },
                                        {
                                            id: '2d0b079f-06c5-4df0-8ea8-d5b0269dd0db',
                                            screenshotDisplayType: 'APP_IPHONE_65',
                                            screenshots: [
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                                    width: 1242,
                                                },
                                            ],
                                        },
                                    ],
                                },
                                id: '321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                name: 'New Product Page',
                                url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                versions: [
                                    {
                                        id: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                                        state: 'READY_FOR_REVIEW',
                                        version: '1',
                                    },
                                ],
                                visible: true,
                            },
                            itemId: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                            state: 'READY_FOR_REVIEW',
                            type: 'appCustomProductPageVersions',
                        },
                    ],
                    state: 'READY_FOR_REVIEW',
                },
                reviewDetail: {
                    contactEmail: 'aearhart@demo.com',
                    contactFirstName: 'Amelia',
                    contactLastName: 'Earhart',
                    contactPhone: '+(123)456-7891',
                    demoAccountName: null,
                    demoAccountPassword: null,
                    demoAccountRequired: false,
                    notes: '',
                    id: '1234',
                    reviewAttachments: [],
                },
                versionReviewSubmissionItem: {
                    earliestReleaseDate: null,
                    id: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                    releaseType: 'MANUAL',
                    state: 'READY_FOR_REVIEW',
                },
                allInfoPresentForSubmission: true,
                earliestReleaseDate: null,
                exportComplianceInfoUsesEncryption: false,
                phasedRelease: {
                    dayNumber: 0,
                    isManuallyAcceleratedPhasedRollout: false,
                    isRunwayAcceleratedRollout: false,
                    isRunwayPaused: false,
                    startDate: null,
                    state: 'INACTIVE',
                    userFraction: 0,
                    blackoutEndsAt: '2024-05-10T13:33:32.988339868-07:00',
                    changedByAutomation: null,
                    completedAt: null,
                    isOnBlackoutPeriod: false,
                    phasedReleasePercent: 0,
                    isSuperseded: false,
                },
                releaseRequested: false,
                releaseType: 'MANUAL',
            },
            storeUrl: 'https://appstoreconnect.apple.com',
            submittedAt: null,
            workflowData: null,
            reviewSubmissionWithoutAppVersion: false,
            ...generateCommonTestData(platform),
            appStoreType: AppStoreType.Apple,
        };
    } else if (platform === AppPlatform.Android) {
        return {
            autoStagedRolloutAutomationId: null,
            latestReleasePhasedRelease: null,
            latestReleaseVersion: null,
            platform: 'android',
            appStoreData: {
                allInfoPresentForSubmission: true,
                integrationId: 'google',
                phasedRelease: {
                    isManuallyAcceleratedPhasedRollout: false,
                    isRunwayAcceleratedRollout: false,
                    isRunwayPaused: false,
                    state: 'draft',
                    userFraction: 0,
                    phasedReleasePercent: 0,
                    dayNumber: 0,
                    isOnBlackoutPeriod: false,
                    isSuperseded: false,
                },
                state: 'draft',
            },
            storeUrl: 'https://play.google.com/console',
            submittedAt: null,
            workflowData: null,
            reviewSubmissionWithoutAppVersion: false,
            ...generateCommonTestData(platform),
            appStoreType: AppStoreType.Google,
        };
    } else {
        return null;
    }
};

const generateReleaseStepMetadataData = (platform: AppPlatform) => {
    if (platform === AppPlatform.Ios) {
        return {
            appStoreVersionExists: false,
            isApproved: false,
            translationsSourceLocale: 'en-US',
            primaryLocale: 'en-US',
            appStoreType: 'AppStoreConnect',
            platform: 'ios',
            translationStatuses: [
                {
                    id: 'en-US',
                    locale: 'en-US',
                    appName: 'synced',
                    description: 'synced',
                    keywords: 'synced',
                    promotionalText: 'synced',
                    shortDescription: 'synced',
                    whatsNew: 'synced',
                    subtitle: 'uploadNeeded',
                },
                {
                    id: 'es-ES',
                    locale: 'es-ES',
                    appName: 'synced',
                    description: 'exportNeeded',
                    keywords: 'synced',
                    promotionalText: 'synced',
                    shortDescription: 'synced',
                    whatsNew: 'exportNeeded',
                    subtitle: 'translationsPending',
                },
            ],
            localizations: [
                {
                    description: 'This is a fun demo app to show you how cool releasing can be using Runway!',
                    displayLocale: 'American English',
                    id: '3.97.0:en-US',
                    keywords: 'mobile,releases',
                    locale: 'en-US',
                    appName: 'Appollo',
                    subtitle: 'Released via Runway',
                    promotionalText: null,
                    status: 'ready',
                    whatsNew:
                        'Minor bugfixes, some cool new features, and some foundational changes to keep things running smoothly!!',
                },
                {
                    appName: 'Appollo',
                    subtitle: 'Released via Runway',
                    description:
                        'Un demo divertido para enseñarles que facil es desarrollar applicaciones usando Runway!',
                    displayLocale: 'European Spanish',
                    id: '3.97.0:es-ES',
                    keywords: 'mobile,releases',
                    locale: 'es-ES',
                    promotionalText: null,
                    status: 'pending-translations',
                    whatsNew: 'Correcciónes de errores y mejoras menores.',
                },
            ],
            requiresApproval: true,
            storeUrl: 'https://appstoreconnect.apple.com',

            ...generateCommonTestData(platform),
        };
    } else if (platform === AppPlatform.Android) {
        return {
            appStoreVersionExists: false,
            isApproved: false,
            appStoreType: 'GooglePlay',
            platform: 'android',
            translationStatuses: [
                {
                    id: 'en-US',
                    locale: 'en-US',
                    appName: 'synced',
                    description: 'synced',
                    keywords: 'synced',
                    promotionalText: 'synced',
                    shortDescription: 'synced',
                    whatsNew: 'synced',
                    subtitle: 'uploadNeeded',
                },
                {
                    id: 'es-ES',
                    locale: 'es-ES',
                    appName: 'synced',
                    description: 'exportNeeded',
                    keywords: 'synced',
                    promotionalText: 'synced',
                    shortDescription: 'synced',
                    whatsNew: 'translationsPending',
                    subtitle: 'translationsPending',
                },
            ],
            localizations: [
                {
                    shortDescription: 'This is a fun demo app to show you how cool releasing can be using Runway!',
                    displayLocale: 'American English',
                    id: '1.25.0:en-US',
                    keywords: null,
                    locale: 'en-US',
                    promotionalText: null,
                    status: 'ready',
                    appName: 'Appollo',
                    whatsNew: "Bug fixes and improvements... we're always working hard to build a better app for you!",
                },
                {
                    shortDescription: 'Un demo para enseñarles que facil es desarrollar applicaciones usando Runway!',
                    displayLocale: 'European Spanish',
                    id: '1.25.0:es-ES',
                    keywords: null,
                    locale: 'es-ES',
                    promotionalText: null,
                    status: 'pending-translations',
                    appName: 'Appollo',
                    whatsNew: "Bug fixes and improvements... we're always working hard to build a better app for you!",
                },
            ],
            requiresApproval: true,
            storeUrl: 'https://play.google.com/console',
            translationsSourceLocale: "'en-US",
            primaryLocale: 'en-US',
            ...generateCommonTestData(platform),
        };
    } else {
        return null;
    }
};

const generateReleaseStepStoreReviewData = (platform: AppPlatform) => {
    if (platform === AppPlatform.Ios) {
        return {
            timeWaitingForReview: 1000,
            timeInReview: 2000,
            platform: 'ios',
            appStoreType: 'AppStoreConnect',
            appStoreData: {
                customProductPages: [
                    {
                        ascLink:
                            'https://appstoreconnect.apple.com/apps/1234/distribution/productpages/92904ee5-8644-4d83-b585-e56dfab21062',
                        firstVersionLocalization: {
                            appPreviewSets: [],
                            id: 'e389095f-a40a-4ee3-873b-194456e096d9',
                            locale: 'en-US',
                            promotionalText: '',
                            screenshotSets: [
                                {
                                    id: '57cd0dd4-70e4-45c6-b722-95971b96688e',
                                    screenshotDisplayType: 'APP_IPHONE_55',
                                    screenshots: [
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                            width: 1242,
                                        },
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                            width: 1242,
                                        },
                                    ],
                                },
                                {
                                    id: '2d0b079f-06c5-4df0-8ea8-d5b0269dd0db',
                                    screenshotDisplayType: 'APP_IPHONE_65',
                                    screenshots: [
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                            width: 1242,
                                        },
                                        {
                                            height: 2208,
                                            id: '',
                                            uploadError: null,
                                            url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                            width: 1242,
                                        },
                                    ],
                                },
                            ],
                        },
                        id: '92904ee5-8644-4d83-b585-e56dfab21062',
                        name: 'Another product page',
                        url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=92904ee5-8644-4d83-b585-e56dfab21062',
                        versions: [
                            {
                                id: '21dd3774-cee0-4b76-97bf-6736f9ee1ed1',
                                state: 'APPROVED',
                                version: '1',
                            },
                        ],
                        visible: true,
                    },
                ],
                inAppEvents: [
                    {
                        ascLink: 'https://appstoreconnect.apple.com/apps/595068603/distribution/events/6502416798',
                        badge: 'LIVE_EVENT',
                        eventState: 'DRAFT',
                        id: '6502416798',
                        longDescription: 'Join us for a live stream demo...',
                        previewImages: [
                            {
                                height: 1080,
                                type: 'EVENT_CARD',
                                url: 'https://is1-ssl.mzstatic.com/image/thumb/eVpKWMMqHdOq-dYA8MYZOw/192x108bb.jpg',
                                width: 1920,
                            },
                            {
                                height: 1920,
                                type: 'EVENT_DETAILS_PAGE',
                                url: 'https://is1-ssl.mzstatic.com/image/thumb/t-pvtnJkPMCLjjkRyB5BGA/108x192bb.jpg',
                                width: 1080,
                            },
                        ],
                        primaryLocale: 'en-US',
                        referenceName: 'New Live Stream Event',
                        shortDescription: 'Live stream demo of New',
                        territorySchedules: [
                            {
                                eventEnd: '2024-05-13T20:00:00Z',
                                eventStart: '2024-05-13T18:00:00Z',
                                publishStart: '2024-05-09T22:00:00Z',
                                territories: [],
                            },
                        ],
                    },
                ],
                integrationId: 'apple',
                relevantReviewSubmission: {
                    appStoreVersionForReviewId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                    id: 'b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                    buildSubmissionStatus: 'UNBLOCKED',
                    reviewSubmissionASCLink:
                        'https://appstoreconnect.apple.com/apps/595068603/distribution/reviewsubmissions/details/b8ee3ad0-9e2f-44c8-8201-af246d8881a5',
                    reviewSubmissionItems: [
                        {
                            id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDZ8ODY1NjczMDQ1',
                            item: null,
                            itemId: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                            state: 'READY_FOR_REVIEW',
                            type: 'appStoreVersions',
                        },
                        {
                            id: 'YjhlZTNhZDAtOWUyZi00NGM4LTgyMDEtYWYyNDZkODg4MWEyfDV8YjFiYjY4MTctZjAwYi00MTQxLTlhMDUtNTdhMzk5ZjQ3YTU0',
                            item: {
                                ascLink:
                                    'https://appstoreconnect.apple.com/apps/595068603/distribution/productpages/321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                firstVersionLocalization: {
                                    appPreviewSets: [],
                                    id: '8a4cd3d8-d561-4e28-8d7d-bc17ad7f2640',
                                    locale: 'en-US',
                                    promotionalText: '',
                                    screenshotSets: [
                                        {
                                            id: 'b0cbe1b8-58e8-49b7-b252-ab044823a0cf',
                                            screenshotDisplayType: 'APP_IPHONE_55',
                                            screenshots: [
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/cd/b8/93/cdb893fd-e3c9-eca1-fbcd-ebf25a615954/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f8/f6/f5/f8f6f515-9578-6dbc-b0f0-07eff74dec90/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/04/58/6e/04586e47-9e3b-fd53-7a5c-cbd3727e8ee3/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/5b/2c/6a/5b2c6aa0-26cd-176c-4dc3-dc18c00a71e9/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/9e/cd/b3/9ecdb3ed-3903-a6ba-c763-6b0fe0d582a7/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/b7/cc/35b7cc25-3063-e89f-1331-09dc8ab7503a/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2208,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a7/dd/d2/a7ddd2df-2193-a9dc-d253-220390831712/pr_source.png/124x220bb.png',
                                                    width: 1242,
                                                },
                                            ],
                                        },
                                        {
                                            id: '10d76fca-af3e-4e8f-b495-be684bd77eb3',
                                            screenshotDisplayType: 'APP_IPHONE_65',
                                            screenshots: [
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c5/da/6f/c5da6fb9-e057-6ac1-868c-5bd05eeded37/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/42/7a/87/427a879e-4203-c935-b170-d59a1824d857/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/74/3e/43/743e4313-7958-3b78-7c44-59835bf7c3a2/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d1/49/04/d149045e-1fdc-306c-d26a-c19ddb33671d/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/fa/b8/7f/fab87fa5-4c67-36b2-3883-31707143fbfe/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ad/ef/86/adef86be-4a15-471b-e47d-24f139e75338/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                                {
                                                    height: 2688,
                                                    id: '',
                                                    uploadError: null,
                                                    url: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/19/24/1d/19241d4d-2621-1210-32af-756884333aee/pr_source.png/124x268bb.png',
                                                    width: 1242,
                                                },
                                            ],
                                        },
                                    ],
                                },
                                id: '321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                name: 'New Product Page',
                                url: 'https://apps.apple.com/us/app/appollo/id595068603?ppid=321b8676-a7a2-4a2e-8614-6ea4e7a9a2f3',
                                versions: [
                                    {
                                        id: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                                        state: 'READY_FOR_REVIEW',
                                        version: '1',
                                    },
                                ],
                                visible: true,
                            },
                            itemId: 'b1bb6817-f00b-4141-9a05-57a399f47a54',
                            state: 'READY_FOR_REVIEW',
                            type: 'appCustomProductPageVersions',
                        },
                    ],
                    state: 'READY_FOR_REVIEW',
                },
                reviewDetail: {
                    contactEmail: 'aearhart@demo.com',
                    contactFirstName: 'Amelia',
                    contactLastName: 'Earhart',
                    contactPhone: '+(123)456-7891',
                    demoAccountName: null,
                    demoAccountPassword: null,
                    demoAccountRequired: false,
                    notes: '',
                    id: '1234',
                    reviewAttachments: [],
                },
                versionReviewSubmissionItem: {
                    earliestReleaseDate: null,
                    id: '80aa1499-4afa-46a1-84b8-7377f74cfb66',
                    releaseType: 'MANUAL',
                    state: 'READY_FOR_REVIEW',
                },
                allInfoPresentForSubmission: true,
                earliestReleaseDate: null,
                exportComplianceInfoUsesEncryption: false,
                phasedRelease: {
                    dayNumber: 0,
                    isManuallyAcceleratedPhasedRollout: false,
                    isRunwayAcceleratedRollout: false,
                    isRunwayPaused: false,
                    startDate: null,
                    state: 'INACTIVE',
                    userFraction: 0,
                    blackoutEndsAt: '2024-05-10T13:33:32.988339868-07:00',
                    changedByAutomation: null,
                    completedAt: null,
                    isOnBlackoutPeriod: false,
                    phasedReleasePercent: 0,
                    isSuperseded: false,
                },
                releaseRequested: false,
                releaseType: 'MANUAL',
            },
            approvedAt: null,
            devRejectedAt: null,
            startedReviewAt: null,
            storeRejectedAt: null,
            storeUrl: 'https://appstoreconnect.apple.com',
            submittedAt: null,
            ...generateCommonTestData(platform),
        };
    } else if (platform === AppPlatform.Android) {
        return {
            timeWaitingForReview: null,
            timeInReview: null,
            platform: 'android',
            appStoreType: 'GooglePlay',
            appStoreData: {
                allInfoPresentForSubmission: true,
                integrationId: 'google',
                phasedRelease: {
                    isManuallyAcceleratedPhasedRollout: false,
                    isRunwayAcceleratedRollout: false,
                    isRunwayPaused: false,
                    state: 'draft',
                    userFraction: 0,
                    phasedReleasePercent: 0,
                    dayNumber: 0,
                    isOnBlackoutPeriod: false,
                    isSuperseded: false,
                },
                state: 'draft',
            },
            approvedAt: null,
            devRejectedAt: null,
            startedReviewAt: null,
            storeRejectedAt: null,
            storeUrl: 'https://play.google.com/console',
            submittedAt: null,
            ...generateCommonTestData(platform),
        };
    } else {
        return null;
    }
};

const generateReleaseStepKickoffData: (platform: AppPlatform) => RecursiveStringifyEnums<ReleaseStepKickoffData> = (
    platform,
) => {
    if (platform === AppPlatform.Ios) {
        return {
            appUsesStaticReleaseBranch: true,
            bumpVersionStatus: 'detected',
            canPerformBumpVersion: true,
            canPerformCodePromotion: true,
            codePromotionPullRequest: {
                id: '1234',
                number: 119,
                status: 'merged',
                title: 'Merge development -\u003e main',
                url: 'https://github.com/runway/demo-ios/pull/119',
                pullRequestType: 'PromoteCode',
                owner: 'runway',
                baseBranch: '',
                filesChanged: [],
            },
            didRunwayCreateReleaseBranch: false,
            codePromotionStatus: 'detected',
            doesReleaseBranchExist: true,
            hasPerformedAnyCodePromotion: true,
            hotfixBranchingBase: null,
            previousReleaseTag: 'v1.0.0',
            previousReleaseVersion: '1.0.0',
            previousTaggedReleaseTag: 'v1.0.0',
            previousTaggedReleaseTagVersionsBehind: 0,
            releaseBranchCodeVersionData: {
                branchName: 'main',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            workingBranchCodeVersionData: {
                branchName: 'master',
                bumpVersionPullRequest: {
                    id: 'PR_123',
                    number: 96,
                    pullRequestType: 'BumpVersion',
                    status: 'merged',
                    title: 'Bumping version to 1.0.0',
                    url: 'https://github.com/runway-org/fake-app/pull/96',
                    owner: 'runway',
                    baseBranch: '',
                    filesChanged: [],
                },
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            releaseBranchDiffUrl: 'https://github.com/runway/demo-ios/compare',
            releaseBranchUrl: 'https://github.com/runway/demo-ios/tree/main',
            resolvedFeatureAffiliations: [
                { affiliationType: 'jira-fix-version', integrationId: 'jira', resolvedString: '1.0.0' },
                { affiliationType: 'jira-label', integrationId: 'jira', resolvedString: 'release-1.0.0' },
            ],
            workingBranchDiffUrl: 'https://github.com/runway/demo-ios/compare',
            releasePlanningSummary:
                '### Major release! Redesign of product page, checkout\n\n- major redesign of product page, rolled out initially under A/B test\n- major redesign of checkout, full rollout to everyone\n- bug fixes\n',
            ...generateCommonTestData(platform),
        };
    } else if (platform === AppPlatform.Android) {
        return {
            releasePlanningSummary:
                '### Major release! Redesign of product page, checkout\n\n- major redesign of product page, rolled out initially under A/B test\n- major redesign of checkout, full rollout to everyone\n- bug fixes\n',
            appUsesStaticReleaseBranch: false,
            didRunwayCreateReleaseBranch: false,
            releaseBranchCodeVersionData: {
                branchName: 'main',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            releaseBranchCodbaseReleaseStepsAndroideVersionData: {
                branchName: 'main',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            workingBranchCodeVersionData: {
                branchName: 'master',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            canPerformCodePromotion: false,
            codePromotionPullRequest: null,
            codePromotionStatus: 'detected',
            doesReleaseBranchExist: true,
            hasPerformedAnyCodePromotion: false,
            hotfixBranchingBase: null,
            previousReleaseTag: 'v1.24.0',
            previousReleaseVersion: '1.24.0',
            previousTaggedReleaseTag: 'v1.24.0',
            previousTaggedReleaseTagVersionsBehind: 0,
            releaseBranchDiffUrl: 'https://github.com',
            releaseBranchUrl: 'https://github.com',
            resolvedFeatureAffiliations: [
                { affiliationType: 'jira-fix-version', integrationId: 'jira', resolvedString: '3.97.0' },
            ],
            workingBranchDiffUrl: null,
            ...generateCommonTestData(platform),
        };
    } else {
        return {
            didRunwayCreateReleaseBranch: false,
            appUsesStaticReleaseBranch: false,
            releaseBranchCodeVersionData: {
                branchName: 'main',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            workingBranchCodeVersionData: {
                branchName: 'master',
                bumpVersionPullRequest: null,
                bumpVersionStatus: 'detected',
                canPerformBumpVersion: false,
                currentCodeVersion: '1.0.0',
                targetCodeVersion: '1.0.0',
            },
            canPerformCodePromotion: false,
            codePromotionPullRequest: null,
            codePromotionStatus: 'detected',
            doesReleaseBranchExist: true,
            hasPerformedAnyCodePromotion: false,
            hotfixBranchingBase: null,
            previousReleaseTag: '1.2.0',
            previousReleaseVersion: '1.2.0',
            previousTaggedReleaseTag: '1.2.0',
            previousTaggedReleaseTagVersionsBehind: 0,
            releaseBranchDiffUrl: 'https://github.com/demo/fake-react-native/compare',
            releaseBranchUrl: 'https://github.com/demo/fake-react-native',
            resolvedFeatureAffiliations: [
                {
                    affiliationType: 'jira-fix-version',
                    integrationId: 'jira',
                    resolvedString: 'codepush-1.0.0',
                },
                { affiliationType: 'jira-label', integrationId: 'jira', resolvedString: 'codepush-1.0.0' },
            ],
            workingBranchDiffUrl: null,
            releasePlanningSummary: '- fixes to product page\n- checkout page address change improvements',
            ...generateCommonTestData(platform),
        };
    }
};

const baseReleaseStepsiOS: () => RecursiveStringifyEnums<ReleaseStep[]> = () => [
    {
        type: 'kickoff',
        id: '1.0.0#kickoff',
        description: 'Kickoff',
        status: 'ready',
        blockingConfig: 'Blocking',
        statusReasonString: 'Kicked off!',
        data: generateReleaseStepKickoffData(AppPlatform.Ios),
        groupIndex: 0,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'abc',
                title: 'Pre-kickoff reminders',
                description: 'Description   \u003cb\u003eyo\u003c/b\u003e !!',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-02-27T23:05:20.886428625Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'def',
                title: 'Send out reminder for upcoming release deadlines',
                description: 'Some detail',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-03T18:03:32.236911544Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: {
                    comment: 'Reminder sent via email',
                    createdAt: '2022-03-03T18:00:32.236911544Z',
                    createdBy: 'aearhart@demo.com',
                },
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'jkl',
                title: 'Verify versioning with product team',
                description: null,
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: [],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-03T18:03:33.133516479Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Kick off release on target date',
                type: 'AutoKickoff',
                id: 'AutoKickoff',
                stepConfigId: null,
                description:
                    'Runway will create a release branch off of your working branch for the next release on the scheduled date.',
                scheduledAt: '2022-12-21T18:00:00Z',
                status: 'success',
                statusMessage: null,
                statusMessageLinkUrl: null,
                isPartOfSequence: true,
                sequenceNumber: 0,
                isLifecycle: true,
                autoScheduledFromCadence: false,
                relevantPRs: [],
            },
            {
                name: 'Bump version',
                type: 'AutoBumpVersion',
                id: 'AutoBumpVersion',
                stepConfigId: null,
                description:
                    'Runway will bump the version on your working branch or release branch according to the strategy set for the app.',
                scheduledAt: '2022-12-21T18:00:00Z',
                status: 'success',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: true,
                sequenceNumber: 1,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Trigger workflow after release kickoff',
                type: 'AutoKickoffTriggerWorkflow',
                id: 'AutoKickoffTriggerWorkflow',
                stepConfigId: null,
                description: 'Runway will trigger the configured CI build workflow after release is kicked off.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: 'Auto trigger workflow is not enabled',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create and sync App Store Connect versions as needed to match current Runway release',
                type: 'AutoCreateAppStoreVersions',
                id: 'AutoCreateAppStoreVersions',
                stepConfigId: null,
                description:
                    'Runway will create a new version of your app in App Store Connect once the next release is being prepared in Runway.',
                scheduledAt: '2022-12-19T04:45:24.970688573Z',
                status: 'success',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create upcoming version in Runway when current release is kicked off',
                type: 'AutoCreateRunwayReleases',
                id: 'AutoCreateRunwayReleases',
                stepConfigId: null,
                description:
                    'Runway will create a new release record for your next version when your current release is kicked off. This will assign a release pilot and provide a selectable upcoming release via the versions timeline in App Home.',
                scheduledAt: null,
                status: 'success',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Merge pull requests opened by Runway',
                type: 'AutoMergeRunwayPRs',
                id: 'AutoMergeRunwayPRs',
                stepConfigId: null,
                description:
                    'Runway creates pull requests to fulfill certain tasks (e.g. bumping version in code). If enabled, Runway will attempt to merge these PRs automatically, once any status checks or approvals are satisfied.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create release-specific Slack channel(s)',
                type: 'AutoCreateReleaseChannels',
                id: 'AutoCreateReleaseChannels',
                stepConfigId: null,
                description:
                    'Runway will automatically create new Slack channel(s) for the release, if you have any release-specific channels configured (e.g. release-{version}) in settings.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
    },
    {
        type: 'featureReadiness',
        id: '1.0.0#featureReadiness',
        description: 'Feature readiness',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'Some work for this release is not yet complete.',
        data: featuresStep(AppPlatform.Ios),
        groupIndex: 0,
        orderIndex: 1,
        checklistItems: [
            {
                id: 'abc',
                title: 'Verify production feature flags are correct for this release',
                description: null,
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'featureReadiness',
                approverGroups: ['engineer'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-15T22:54:38.462070296Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'def',
                title: 'Update CMS version flags for this release',
                description: '',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'featureReadiness',
                approverGroups: [],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-15T22:54:39.472656772Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Add appropriate labels and/or fix versions when they are missing from tickets',
                type: 'AutoAddMissingFAs',
                id: 'AutoAddMissingFAs',
                stepConfigId: null,
                relevantPRs: [],

                description:
                    'Runway will add appropriate labels and/or fix versions when they are missing from tickets that are associated with the release. These label and fix version patterns are defined in App Settings.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
            },
        ],
    },
    {
        type: 'translations',
        id: '1.0.0#translations',
        description: 'Translations',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'Waiting for translations from Crowdin',
        data: {
            isApproved: false,
            translationsData: {
                ...translationData,
                keys: Object.values(translationData.byKey),
                workingBranchKeys: Object.values(translationData.workingBranchStrings),
            },
        },
        groupIndex: 0,
        orderIndex: 2,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Update translations on the release branch from the working branch',
                type: 'AutoCherryPickLocalizableStrings',
                id: 'AutoCherryPickLocalizableStrings',
                stepConfigId: null,
                description:
                    'Runway will update translations on the release branch by pulling over new translations from the working branch as needed.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],

                hasEditableSettings: true,
            },
            {
                name: 'Sync metadata translations',
                type: 'AutoSyncMetadataTranslations',
                id: 'AutoSyncMetadataTranslations',
                stepConfigId: null,
                description:
                    'Runway will upload release metadata for translation if needed and export translated metadata to App Store Connect when ready.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                hasEditableSettings: true,
                relevantPRs: [],
            },

            {
                name: 'Sync localizable string translations',
                type: 'AutoSyncTranslations',
                id: 'AutoSyncTranslations',
                stepConfigId: null,
                description:
                    'Runway will upload new or updated strings for translation as needed, and export strings from the provider and open a pull request when ready.',
                relevantPRs: [],

                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                hasEditableSettings: true,
            },
        ],
    },
    {
        type: 'releaseCandidate',
        id: '1.0.0#releaseCandidate',
        description: 'CI',
        status: 'ready',
        blockingConfig: 'Blocking',
        statusReasonString: 'CI build succeeded.',
        data: {
            builds: [
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '298',
                        id: '123',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T12:31:21-07:00',
                    },
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [
                            {
                                appStoreInfos: {
                                    'apple:12345': {
                                        ascTransactionId: 'OKDNVIADOWDK',
                                        createdAt: '2024-06-13T21:26:13.418046117Z',
                                        destinationInstallationId: 'apple:12345',
                                        errorMessage: null,
                                        trackName: null,
                                        uploadCompletedAt: '2024-06-13T21:27:34.052406613Z',
                                        uploadRetryCount: 1,
                                        uploadStatus: 'success',
                                    },
                                },
                                artifactId: '9112c5f888b77a8a',
                                binaryBuildDetails: {
                                    appName: 'appollo-ios',
                                    artifactType: 'BuildArtifactIOSAppStore',
                                    buildIdentifier: '4248',
                                    bundleName: 'com.demo.demo',
                                    provisioningProfile: {
                                        bundleAppStoreId: '',
                                        bundleId: '',
                                        certificates: [
                                            {
                                                certificateType: 'DISTRIBUTION',
                                                expirationDate: '2025-02-07T16:55:18Z',
                                                id: '',
                                                name: 'Apple Distribution: Appollo, LLC',
                                            },
                                        ],
                                        createdByRunwayAt: null,
                                        creationDate: '0001-01-01T00:00:00Z',
                                        devices: null,
                                        expirationDate: '2025-02-07T16:55:18Z',
                                        id: '39X3JLS85F',
                                        name: 'Bitrise iOS app-store - (com.demo.demo)',
                                        profileState: 'ACTIVE',
                                        profileType: 'IOS_APP_STORE',
                                    },
                                    versionString: '1.1.0',
                                },
                                downloadUrl:
                                    'https://demo.runway.team/api/org/demo/app/demo/release/demo-ios:1.1.0/artifact?artifactId=3f686ac9386fd0aa\u0026buildId=555600c7-de5c-4829-b267-f19ac3b13ae9',
                                dsymUploadInfo: null,
                                fileName: 'demo.ipa',
                                size: 40,
                                version: '1.1.0',
                                workflowRunId: '555600c7-de5c-4829-b267-f19ac3b13ae9',
                            },
                            {
                                appStoreInfos: null,
                                artifactId: 'bd255bd2d24833f5',
                                binaryBuildDetails: null,
                                downloadUrl:
                                    'https://demo.runway.team/api/org/demo/app/appollo/release/appollo-ios:1.1.0/artifact?artifactId=3f686ac9386fd0aa\u0026buildId=555600c7-de5c-4829-b267-f19ac3b13ae9',
                                dsymUploadInfo: {
                                    createdAt: '2024-06-13T21:26:14.254888791Z',
                                    errorMessage: null,
                                    projectName: 'Appollo',
                                    uploadCompletedAt: '2024-06-13T21:26:19.858624994Z',
                                    uploadRetryCount: 1,
                                    uploadStatus: 'success',
                                },
                                fileName: 'mercury.dSYM.zip',
                                size: 24,
                                version: '1.1.0',
                                workflowRunId: '555600c7-de5c-4829-b267-f19ac3b13ae9',
                            },
                        ],
                        branch: 'main',
                        buildFinishedAt: '2022-03-21T17:32:25Z',
                        buildHash: 'zcebLLhLwk8m-GonPSg84G6omXw=',
                        buildIdentifier: '298',
                        buildStartedAt: '2022-03-21T17:23:53Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/abc',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: 'abc',
                    },
                    isSelectedBuild: true,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '297',
                        id: '123',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T12:31:21-07:00',
                    },
                    ciBuild: {
                        artifacts: [
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.dSYM.zip',
                                size: 16,
                            },
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.ipa',
                                size: 139,
                            },
                        ],
                        commitUrl: '',
                        branch: 'main',
                        buildFinishedAt: '2022-03-15T19:28:41Z',
                        buildHash: '123=',
                        buildIdentifier: '297',
                        buildStartedAt: '2022-03-15T19:17:48Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '123',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '296',
                        id: 'abc',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-15T11:50:03-07:00',
                    },
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.ipa',
                                size: 139,
                            },
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.dSYM.zip',
                                size: 16,
                            },
                        ],
                        branch: 'main',
                        buildFinishedAt: '2022-03-15T18:46:11Z',
                        buildHash: 'abcd',
                        buildIdentifier: '296',
                        buildStartedAt: '2022-03-15T18:35:29Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/abc',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: 'abc-abc-abc',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: null,
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [],
                        branch: 'main',
                        buildFinishedAt: '2022-03-15T18:35:29Z',
                        buildHash: 'def',
                        buildIdentifier: '295',
                        buildStartedAt: '2022-03-15T18:33:17Z',
                        buildStatus: 'stopped',
                        buildUrl: 'https://app.bitrise.io/build/def',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main`.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Stopped',
                        workflowRunId: '123-123-123',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '290',
                        id: 'bef',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-11T12:08:29-08:00',
                    },
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.dSYM.zip',
                                size: 16,
                            },
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.ipa',
                                size: 139,
                            },
                        ],
                        branch: 'main',
                        buildFinishedAt: '2022-03-11T20:05:46Z',
                        buildHash: 'cya',
                        buildIdentifier: '290',
                        buildStartedAt: '2022-03-11T19:55:17Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: 'cya-cya',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '289',
                        id: '123',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-10T08:20:05-08:00',
                    },
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.dSYM.zip',
                                size: 16,
                            },
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'app.ipa',
                                size: 139,
                            },
                        ],
                        branch: 'main',
                        buildFinishedAt: '2022-03-10T16:16:53Z',
                        buildHash: '123-abc',
                        buildIdentifier: '289',
                        buildStartedAt: '2022-03-10T16:06:14Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/123-abc',
                        commit: '0facaf1063bfa427b4bb1b5dba5b35d662c3bf45',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #118 from demo/development\n\nRunway promoted branch `development` to `main`.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '123-abc',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: {
                            autoNotifyEnabled: true,
                            externalBuildState: 'IN_BETA_TESTING',
                            internalBuildState: 'IN_BETA_TESTING',
                        },
                        buildNumber: '284',
                        id: '123',
                        integrationId: 'apple',
                        isProcessed: true,
                        processingState: 'VALID',
                        type: 'ios-binary',
                        uploadedAt: '2022-03-03T10:09:08-08:00',
                    },
                    ciBuild: {
                        commitUrl: '',
                        artifacts: [
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'demo.ipa',
                                size: 139,
                            },
                            {
                                downloadUrl: 'https://demo.runway.team',
                                fileName: 'mercury.dSYM.zip',
                                size: 16,
                            },
                        ],
                        branch: 'main',
                        buildFinishedAt: '2022-03-03T18:05:50Z',
                        buildHash: 'ux-OXdNnKuSGcQGoUxWVzOmXmBk=',
                        buildIdentifier: '284',
                        buildStartedAt: '2022-03-03T17:55:15Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/123',
                        commit: '0facaf1063bfa427b4bb1b5dba5b35d662c3bf45',
                        commitAuthor: 'runway-github[bot]',
                        commitMessage:
                            'Merge pull request #118 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: 'abc-def-hij',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
            ],
            workflowData: {
                branch: 'main',
                headCommit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                headCommitAuthor: 'runway-github[bot]',
                headCommitMessage:
                    'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                integrationType: 'bitrise',
                workflowName: 'deploy',
                workflowType: 'staging',
                workflowUrl: 'https://app.bitrise.io/app/123/workflow_editor',
            },
        },
        groupIndex: 1,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Enable artifact downloads',
                type: 'AutoDownloadArtifacts',
                id: 'AutoDownloadArtifacts',
                stepConfigId: null,
                description:
                    'Runway will download all artifacts generated from your build workflow and provide direct download links to them from the Runway interface. Additionally, Runway will include artifact information in Slack build success notifications, including a link to find those downloads in Runway.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
    },
    {
        type: 'regressionTesting',
        id: '1.0.0#regressionTesting',
        description: 'Regression testing',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'Regression testing in progress...',
        data: {
            availableBuilds: [
                {
                    appStoreBuildIdentifier: '297',
                    appStoreIntegrationId: 'apple',
                    buildIdentifier: '297',
                    hash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '296',
                    appStoreIntegrationId: 'apple',
                    buildIdentifier: '296',
                    hash: '0qVMy0jBTbwzL5k67ZzU092K-wA=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '290',
                    appStoreIntegrationId: 'apple',
                    buildIdentifier: '290',
                    hash: 'cYAkkfz3H8wQ_0fBrtp05sJ6uMA=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '289',
                    appStoreIntegrationId: 'apple',
                    buildIdentifier: '289',
                    hash: '2LLiuHxPPvmLOnRjj8SzN86Gx54=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '284',
                    appStoreIntegrationId: 'apple',
                    buildIdentifier: '284',
                    hash: 'ux-OXdNnKuSGcQGoUxWVzOmXmBk=',
                    integrationId: 'bitrise',
                },
            ],
            regressionBuildInfo: {
                associatedAppStoreBuild: {
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    buildNumber: '297',
                    id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                    integrationId: 'apple',
                    isProcessed: true,
                    processingState: 'VALID',
                    type: 'ios-binary',
                    uploadedAt: '2022-03-15T12:31:21-07:00',
                },
                ciBuild: {
                    commitUrl: '',
                    artifacts: null,
                    branch: 'main',
                    buildFinishedAt: '2022-03-15T19:28:41Z',
                    buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                    buildIdentifier: '297',
                    buildStartedAt: '2022-03-15T19:17:48Z',
                    buildStatus: 'success',
                    buildUrl: 'https://app.bitrise.io/build/123',
                    commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                    commitAuthor: 'runway-github[bot]',
                    commitMessage:
                        'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                    integrationId: 'bitrise',
                    providerBuildStatusString: 'Success',
                    workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                },
            },
            status: 'inProgress',
            testItems: [
                {
                    approverGroups: ['qa'],
                    comment: {
                        comment: 'Tested sign in with google, github, apple, all look good',
                        createdAt: '2022-02-27T23:00:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    description: null,
                    id: 'c55n1kdachdaceuvmb00',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'passed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test login flow',
                    type: 'multi',
                    owners: ['ssullenberger@demo.com'],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c8kfkuln86busgdit4ag',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'inProgress',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test "Add receipts" flow',
                    type: 'multi',
                    owners: ['narmstrong@demo.com'],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c55n1p5achdaceuvmb0g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'passed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test checkout flow',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c55n25lachdaceuvmb1g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test "Share with friends" flow',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: 'Remember to test this stuff right now',
                    id: 'c8efiddn86bppsoltosg',
                    notifyEnabled: false,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'failed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Another thing to test',
                    type: 'multi',
                    owners: [],
                },
            ],
            nonHistoricalTestRunsCompletionFraction: 0.95,
            nonHistoricalTestRunsStatusesTotalCount: 30,
            testRuns: [
                {
                    completedAt: null,
                    completedCount: 19,
                    createdAt: '2022-02-17T23:48:12Z',
                    description: '',
                    id: '1',
                    integrationId: 'testrail',
                    isInProgress: true,
                    name: 'Checkout Pathways',
                    statuses: [
                        { color: '6EC78B', count: 19, displayableName: 'Passed', fraction: 0.95 },
                        { color: '595959', count: 0, displayableName: 'Blocked', fraction: 0 },
                        { color: 'd9d9d9', count: 1, displayableName: 'Untested', fraction: 0.05 },
                        { color: 'F4AD22', count: 0, displayableName: 'Retest', fraction: 0 },
                        { color: 'EF2D56', count: 0, displayableName: 'Failed', fraction: 0 },
                    ],
                    totalCount: 20,
                    updatedAt: '2022-02-17T23:52:10Z',
                    url: 'https://demo.testrail.io',
                    completionFraction: 0.95,
                    isHistorical: false,
                },
                {
                    completedAt: null,
                    completedCount: 9,
                    createdAt: '2022-02-17T23:48:12Z',
                    description: '',
                    id: '1',
                    integrationId: 'testrail',
                    isInProgress: true,
                    name: 'Core Pathways',
                    statuses: [
                        { color: '6EC78B', count: 9, displayableName: 'Passed', fraction: 0.55 },
                        { color: '595959', count: 1, displayableName: 'Blocked', fraction: 0.05 },
                        { color: 'd9d9d9', count: 5, displayableName: 'Untested', fraction: 0.3 },
                        { color: 'F4AD22', count: 1, displayableName: 'Retest', fraction: 0.05 },
                        { color: 'EF2D56', count: 2, displayableName: 'Failed', fraction: 0.1 },
                    ],
                    totalCount: 18,
                    updatedAt: '2022-02-17T23:52:10Z',
                    url: 'https://demo.testrail.io',
                    completionFraction: 0.55,
                    isHistorical: false,
                },
                {
                    completedAt: '2022-02-18T23:48:12Z',
                    completedCount: 18,
                    createdAt: '2022-02-17T23:48:12Z',
                    description: '',
                    id: '1',
                    integrationId: 'testrail',
                    isInProgress: false,
                    name: 'Core pathways',
                    statuses: [
                        { color: '6EC78B', count: 10, displayableName: 'Passed', fraction: 1 },
                        { color: '595959', count: 0, displayableName: 'Blocked', fraction: 0 },
                        { color: 'd9d9d9', count: 0, displayableName: 'Untested', fraction: 0 },
                        { color: 'F4AD22', count: 0, displayableName: 'Retest', fraction: 0 },
                        { color: 'EF2D56', count: 0, displayableName: 'Failed', fraction: 0 },
                    ],
                    totalCount: 18,
                    updatedAt: '2022-02-17T23:52:10Z',
                    url: 'https://demo.testrail.io',
                    completionFraction: 1,
                    isHistorical: true,
                },
                {
                    completedAt: '2022-02-18T23:48:12Z',
                    completedCount: 18,
                    createdAt: '2022-02-17T23:48:12Z',
                    description: '',
                    id: '1',
                    integrationId: 'testrail',
                    isInProgress: false,
                    name: 'New user pathway',
                    statuses: [
                        { color: '6EC78B', count: 10, displayableName: 'Passed', fraction: 1 },
                        { color: '595959', count: 0, displayableName: 'Blocked', fraction: 0 },
                        { color: 'd9d9d9', count: 0, displayableName: 'Untested', fraction: 0 },
                        { color: 'F4AD22', count: 0, displayableName: 'Retest', fraction: 0 },
                        { color: 'EF2D56', count: 0, displayableName: 'Failed', fraction: 0 },
                    ],
                    totalCount: 18,
                    updatedAt: '2022-02-17T23:52:10Z',
                    url: 'https://demo.testrail.io',
                    completionFraction: 1,
                    isHistorical: true,
                },
            ],
            updatedAt: '2022-03-15T18:57:32.629493-04:00',
        },
        groupIndex: 1,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [],
    },
    {
        type: 'betaTesting',
        id: '1.0.0#betaTesting',
        description: 'Beta testing',
        status: 'ready',
        blockingConfig: 'Blocking',
        statusReasonString: 'Beta testing completed!',
        data: {
            betaBuilds: [
                {
                    betaGroups: ['6c1c4439-16cb-49e8-b7c4-97d7c1f46a51', '7874adb9-9af0-427f-aabd-f7d36bed9049'],
                    betaStatus: 'testing',
                    betaTesters: ['aearhart@demo.com', 'charles@demo.com', 'jimmy@demo.com'],
                    betaTestingNotes: [
                        {
                            displayLocale: 'American English',
                            id: 'cc6e2e20-0b62-441e-b755-594bed74b9e6',
                            locale: 'en-US',
                            notes: 'Test bug fixes on product page, checkout new design.',
                        },
                    ],
                    buildId: '475bf507-c3c4-443f-9845-932f16748ec7',
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '298',
                            id: '475bf507-c3c4-443f-9845-932f16748ec7',
                            integrationId: 'apple-beta',
                            isProcessed: true,
                            processingState: 'VALID',
                            type: 'ios-binary',
                            uploadedAt: '2022-03-15T18:07:07-07:00',
                        },
                        associatedCIBuild: {
                            commitUrl: '',

                            branch: 'main',
                            buildFinishedAt: '2022-03-15T18:46:11Z',
                            buildHash: '0qVMy0jBTbwzL5k67ZzU092K-wA=',
                            buildIdentifier: '298',
                            buildStartedAt: '2022-03-15T18:35:29Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io/build/123',
                            commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                            commitAuthor: null,
                            commitMessage:
                                'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '482375f7-5c67-46a0-b3f3-0e24907c2e3c',
                        },
                        stabilityInfo: {},
                    },
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    isConsideredExternal: true,
                    isLatestBuild: true,
                    isSelectedBuild: true,
                    metrics: { numInstalls: 0 },
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    betaGroups: ['6c1c4439-16cb-49e8-b7c4-97d7c1f46a51', '7874adb9-9af0-427f-aabd-f7d36bed9049'],
                    betaStatus: 'testing',
                    betaTesters: [],
                    betaTestingNotes: [
                        {
                            displayLocale: 'American English',
                            id: 'ea1599fb-b230-4966-b044-5f2ac9be42ab',
                            locale: 'en-US',
                            notes: '',
                        },
                    ],
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '297',
                            id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                            integrationId: 'apple-beta',
                            isProcessed: true,
                            processingState: 'VALID',
                            type: 'ios-binary',
                            uploadedAt: '2022-03-15T12:31:21-07:00',
                        },
                        associatedCIBuild: {
                            commitUrl: '',
                            branch: 'main',
                            buildFinishedAt: '2022-03-15T19:28:41Z',
                            buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                            buildIdentifier: '297',
                            buildStartedAt: '2022-03-15T19:17:48Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io/build/123',
                            commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                            commitAuthor: null,
                            commitMessage:
                                'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                        },
                    },
                    isConsideredExternal: true,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
                {
                    betaGroups: ['6c1c4439-16cb-49e8-b7c4-97d7c1f46a51', '7874adb9-9af0-427f-aabd-f7d36bed9049'],
                    betaStatus: 'testing',
                    betaTesters: [],
                    betaTestingNotes: [
                        {
                            displayLocale: 'American English',
                            id: 'c4fad929-20ef-4a3e-adc8-58425d2475d1',
                            locale: 'en-US',
                            notes: '',
                        },
                    ],
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '296',
                            id: 'ac1fa4d1-8664-4679-ae19-9842afaff37e',
                            integrationId: 'apple-beta',
                            isProcessed: true,
                            processingState: 'VALID',
                            type: 'ios-binary',
                            uploadedAt: '2022-03-15T11:50:03-07:00',
                        },
                        associatedCIBuild: {
                            commitUrl: '',

                            branch: 'main',
                            buildFinishedAt: '2022-03-15T18:46:11Z',
                            buildHash: '0qVMy0jBTbwzL5k67ZzU092K-wA=',
                            buildIdentifier: '296',
                            buildStartedAt: '2022-03-15T18:35:29Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io/build/123',
                            commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                            commitAuthor: null,
                            commitMessage:
                                'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '482375f7-5c67-46a0-b3f3-0e24907c2e3c',
                        },
                        stabilityInfo: null,
                    },
                    isConsideredExternal: true,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
                {
                    betaGroups: ['6c1c4439-16cb-49e8-b7c4-97d7c1f46a51', '7874adb9-9af0-427f-aabd-f7d36bed9049'],
                    betaStatus: 'testing',
                    betaTesters: [],
                    betaTestingNotes: [
                        {
                            displayLocale: 'American English',
                            id: 'ec4ab077-1e79-4be5-bcfc-7f67fd846b92',
                            locale: 'en-US',
                            notes: '',
                        },
                    ],
                    buildId: 'bb1a73c7-7645-499d-852a-7a6a96c7de30',
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '290',
                            id: 'bb1a73c7-7645-499d-852a-7a6a96c7de30',
                            integrationId: 'apple-beta',
                            isProcessed: true,
                            processingState: 'VALID',
                            type: 'ios-binary',
                            uploadedAt: '2022-03-11T12:08:29-08:00',
                        },
                        associatedCIBuild: {
                            commitUrl: '',

                            branch: 'main',
                            buildFinishedAt: '2022-03-11T20:05:46Z',
                            buildHash: 'cYAkkfz3H8wQ_0fBrtp05sJ6uMA=',
                            buildIdentifier: '290',
                            buildStartedAt: '2022-03-11T19:55:17Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io/build/123',
                            commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                            commitAuthor: null,
                            commitMessage:
                                'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '66dee2d1-be63-43d5-a8b8-24bb8f19efbc',
                        },
                        stabilityInfo: null,
                    },
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    isConsideredExternal: true,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
            ],
            betaGroups: [
                {
                    id: '6c1c4439-16cb-49e8-b7c4-97d7c1f46a51',
                    isExternalGroup: false,
                    name: 'App Store Connect Users',
                    testers: ['info@demo.com'],
                },
                {
                    id: 'ddbcb2dd-a9b3-4763-ba95-9db9f6325c80',
                    isExternalGroup: true,
                    name: 'ITC.apps.tf.labels.CustomGroup1',
                    testers: [
                        'aearhart@demo.com',
                        'sully@demo.com',
                        'buzz@demo.com',
                        'tester1@gmail.com',
                        'tester2@gmail.com',
                        'tester3@gmail.com',
                    ],
                },
                {
                    id: '06c1a5c1-72ee-4ed1-83fd-151229eb9543',
                    isExternalGroup: true,
                    name: 'Another external testing group',
                    testers: null,
                },
                {
                    id: '7874adb9-9af0-427f-aabd-f7d36bed9049',
                    isExternalGroup: true,
                    name: 'The Best People',
                    testers: ['aearhart@demo.com', 'sully@demo.com', 'buzz@demo.com'],
                },
            ],
            buildInfo: {
                associatedAppStoreBuild: {
                    betaBuildDetails: {
                        autoNotifyEnabled: true,
                        externalBuildState: 'IN_BETA_TESTING',
                        internalBuildState: 'IN_BETA_TESTING',
                    },
                    buildNumber: '297',
                    id: 'fdeaddb9-87af-446b-baff-91eb85d1446c',
                    integrationId: 'testflightx',
                    isProcessed: true,
                    processingState: 'VALID',
                    type: 'ios-binary',
                    uploadedAt: '2022-03-15T12:31:21-07:00',
                },
                ciBuild: {
                    artifacts: [
                        {
                            downloadUrl: 'https://demo.runway.team',
                            fileName: 'app.dSYM.zip',
                            size: 16,
                        },
                        {
                            downloadUrl: 'https://demo.runway.team',
                            fileName: 'app.ipa',
                            size: 139,
                        },
                    ],
                    branch: 'main',
                    buildFinishedAt: '2022-03-15T19:28:41Z',
                    buildHash: 'A5LZuDfhn3e6WNweXBzV8AR1w6c=',
                    buildIdentifier: '297',
                    buildStartedAt: '2022-03-15T19:17:48Z',
                    buildStatus: 'success',
                    buildUrl: 'https://app.bitrise.io/build/123',
                    commit: '0fb22bf26bc7c458a518c08d46c162d3045cf329',
                    commitAuthor: 'runway-github[bot]',
                    commitMessage:
                        'Merge pull request #119 from demo/development\n\nRunway promoted branch `development` to `main` for release 3.97.0.',
                    integrationId: 'bitrise',
                    providerBuildStatusString: 'Success',
                    workflowRunId: '0a65a37e-ba7d-45d7-bd3f-3ec0ba117bd8',
                },
                isSelectedBuild: false,
                selectedReason: 'autoRunwaySelection',
            },
            soakDidFinishEarly: true,
            soakFinishedAt: '2022-03-04T18:05:50Z',
            soakStartedAt: '2022-03-16T01:16:18.832845812Z',
            testers: [
                {
                    email: 'tester1@gmail.com',
                    firstName: 'Tester',
                    id: '1',
                    lastName: 'One',
                },
                {
                    email: 'tester2@gmail.com',
                    firstName: 'Tester',
                    id: '2',
                    lastName: 'Two',
                },
                {
                    email: 'tester3@gmail.com',
                    firstName: 'Tester',
                    id: '3',
                    lastName: 'Three',
                },
                {
                    email: 'info@demo.com',
                    firstName: 'Buzz',
                    id: '4',
                    lastName: 'Aldrin',
                },
                {
                    email: 'tester5@gmail.com',
                    firstName: 'Tester',
                    id: '5',
                    lastName: 'Five',
                },
                {
                    email: 'tester6@gmail.com',
                    firstName: 'Tester',
                    id: '6',
                    lastName: 'Six',
                },
                {
                    email: 'tester7@gmail.com',
                    firstName: 'Tester',
                    id: '7',
                    lastName: 'Seven',
                },
            ],
        },
        groupIndex: 1,
        orderIndex: 2,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Assign beta builds to test groups',
                type: 'AutoAssignBetaBuilds',
                id: 'AutoAssignBetaBuilds',
                stepConfigId: null,
                description:
                    'Runway will assign any new builds uploaded to TestFlight to your default beta groups for testing. External testers will have access once the build has been reviewed.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Submit beta builds for review',
                type: 'AutoSubmitBetaBuilds',
                id: 'AutoSubmitBetaBuilds',
                stepConfigId: null,
                description:
                    'Runway will submit any new builds uploaded to TestFlight for beta review as soon as they finish processing.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Apply beta testing notes to new beta builds',
                type: 'AutoApplyBetaBuildNotes',
                id: 'AutoApplyBetaBuildNotes',
                stepConfigId: null,
                description:
                    "Runway will automatically carry over the 'What to Test' notes of the previous TestFlight build to new builds.",
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
    },
    {
        type: 'screenshots',
        id: '1.0.0#screenshots',
        description: 'Screenshots',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'Approval required.',
        data: {
            isApproved: false,
            requiresApproval: true,
            platform: 'ios',
            appStoreType: 'apple',
            screenshotLocalizations: [
                {
                    displayLocale: 'American English',
                    locale: 'en-US',
                    screenshotSets: [
                        {
                            screenshotDisplayType: 'APP_IPHONE_55',
                            screenshots: [
                                {
                                    height: 2208,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                    width: 1242,
                                },
                                {
                                    height: 2208,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                    width: 1242,
                                },
                            ],
                        },
                        {
                            screenshotDisplayType: 'APP_IPHONE_65',
                            screenshots: [
                                {
                                    height: 2688,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                    width: 1242,
                                },
                                {
                                    height: 2688,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                    width: 1242,
                                },
                            ],
                        },
                    ],
                },
                {
                    displayLocale: 'European Spanish',
                    locale: 'es-ES',
                    screenshotSets: [
                        {
                            screenshotDisplayType: 'APP_IPHONE_65',
                            screenshots: [
                                {
                                    height: 2688,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-1.png',
                                    width: 1242,
                                },
                                {
                                    height: 2688,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-iOS-2.png',
                                    width: 1242,
                                },
                            ],
                        },
                    ],
                },
            ],
            storeUrl: 'https://appstoreconnect.apple.com',
        },
        groupIndex: 2,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'c03218kcu89v1j3i28cg',
                title: 'Upload screenshots to ASC per the guidelines',
                description: 'Here are the [guidelines](https://help.apple.com/app-store-connect/#/dev910472ff2).',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'screenshots',
                approverGroups: ['design'],
                releaseTypes: 'all',
                notifyEnabled: false,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [],
    },
    {
        type: 'metadata',
        id: '1.0.0#metadata',
        description: 'Metadata',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'Waiting for manual approval',
        data: generateReleaseStepMetadataData(AppPlatform.Ios),
        groupIndex: 2,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [
            {
                name: "Apply 'What's New' text to new releases in App Store Connect",
                type: 'AutoApplyMetadata',
                id: 'AutoApplyMetadata',
                stepConfigId: null,
                relevantPRs: [],

                description:
                    "Runway will apply 'What's New' text to new versions created in App Store Connect. You can make updates to the text as needed before you submit your update for review.",
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
            },
        ],
    },
    {
        type: 'approvals',
        id: '1.0.0#approvals',
        description: 'Approvals',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: 'There are 13 items that still require approval.',
        data: {
            approvalItems: [
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c51sfnlachdb4vli3720',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'approved',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Mobile - Checkout',
                    type: 'multi',
                    owners: ['ssullenberger@demo.com'],
                },
                {
                    approverGroups: [],
                    comment: {
                        comment: 'Verified on latest, no issues',
                        createdBy: 'aearhart@demo.com',
                        createdAt: '2022-02-27T23:00:20.886428625Z',
                    },
                    description: null,
                    id: 'c51p2qdachdas7jctn8g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'approved',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Security/Ops',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['engineer'],
                    comment: null,
                    description: null,
                    id: 'c51p10dachdas7jctn6g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Mobile - Core',
                    type: 'multi',
                    owners: ['narmstrong@demo.com', 'ssullenberger@demo.com'],
                },
                {
                    approverGroups: ['marketing'],
                    comment: null,
                    description: null,
                    id: 'c55mpltachdaceuvmaug',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Sign-off from marketing',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['pilot'],
                    comment: null,
                    description: null,
                    id: 'c51sif8m221m3fc0c4hg',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Get signoff from security/infra',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['pilot'],
                    comment: null,
                    description: null,
                    id: 'c51sif8m221m3fc0c4i0',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Get signoff from compliance',
                    type: 'multi',
                    owners: [],
                },
            ],
        },
        groupIndex: 3,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [],
    },
    {
        type: 'submission',
        id: '1.0.0#submission',
        description: 'Submission',
        status: 'pending',
        blockingConfig: 'Blocking',
        statusReasonString: '3 checklist items still need to be completed for this step.',
        data: generateReleaseStepSubmissionData(AppPlatform.Ios),
        groupIndex: 4,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'c5n2h7ln86bo9gnibnr0',
                title: 'Thing to do before submit',
                description: 'Do this!',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['approver'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'c8al5bdn86bs44bjrpd0',
                title: 'Another thing to remember before submitting',
                description: 'All this stuff',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['pilot', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'c8e0r55n86boufv00ong',
                title: 'Important Pre-submit step',
                description: 'Remember to do this before submitting.',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['pilot', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: false,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Submit app for review',
                type: 'AutoSubmit',
                id: 'AutoSubmit',
                stepConfigId: null,
                description:
                    'Runway will submit your selected build for review on the scheduled date if all previous steps are ready (green).',
                scheduledAt: '2023-01-06T19:00:00Z',
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: true,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Select build for App Store Connect',
                type: 'AutoSelectLatestBuild',
                id: 'AutoSelectLatestBuild',
                stepConfigId: null,
                relevantPRs: [],

                description:
                    'Runway will select the latest available build for release in App Store Connect. Note that there may be a processing delay of a few minutes.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
            },
        ],
    },
    {
        type: 'storeReview',
        id: '1.0.0#storeReview',
        description: 'App store review',
        status: 'inactive',
        blockingConfig: 'Blocking',
        statusReasonString: 'Waiting for submission.',
        data: generateReleaseStepStoreReviewData(AppPlatform.Ios),
        groupIndex: 4,
        orderIndex: 1,
        checklistItems: [
            {
                id: 'c7oomvdn86bpp9lejr1g',
                title: 'Release via managed publishing if needed',
                description: null,
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'storeReview',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
            {
                id: 'c59kpldachdcretdibcg',
                title: 'Many different users can deal with this',
                description: 'engineers, qa and pms should be able to approve this',
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'storeReview',
                approverGroups: ['engineer', 'qa', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [],
    },
    {
        type: 'takeoff',
        id: '1.0.0#takeoff',
        description: 'Release',
        status: 'inactive',
        blockingConfig: 'Blocking',
        statusReasonString: 'Waiting for App Store review to be completed...',
        data: generateReleaseStepTakeoffData(AppPlatform.Ios),
        groupIndex: 4,
        orderIndex: 2,
        checklistItems: [
            {
                id: 'bvv18nkfoo7cohhp7ju0',
                title: 'Send announcement email to team@ distribution list',
                description: null,
                type: 'binary',
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                statuses: ['approved'],
                releaseStepType: 'takeoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Release app',
                type: 'AutoRelease',
                id: 'AutoRelease',
                stepConfigId: null,
                description:
                    'Runway will release your app update (or start your phased release, if applicable) on the scheduled date if all previous steps are ready (green).',
                scheduledAt: '2023-01-09T19:00:00Z',
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: true,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Tag releases at the end of the release cycle',
                type: 'AutoTagReleases',
                id: 'AutoTagReleases',
                stepConfigId: null,
                description:
                    'Runway will tag your production release commit at the end of each release cycle, and generate a summary of all work going out with the release.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Attach build artifacts to VCS release record when tagging',
                type: 'AutoUploadReleaseAssets',
                id: 'AutoUploadReleaseAssets',
                stepConfigId: null,
                relevantPRs: [],

                description:
                    'When tagging your production release commit, Runway will attach all artifacts generated from your active production build workflow as assets on your release record.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
            },
            {
                name: 'Mark releases as completed in project management tool',
                type: 'AutoCompleteIssueTrackingReleases',
                id: 'AutoCompleteIssueTrackingReleases',
                stepConfigId: null,
                description:
                    'Runway will mark releases as completed in your project management tool at the end of each release cycle.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Halt unstable phased releases',
                type: 'AutoHaltUnstablePhasedReleases',
                id: 'AutoHaltUnstablePhasedReleases',
                stepConfigId: null,
                description:
                    'Runway will pause your phased release if all of your defined conditions have been met, and any of your selected health metrics become unhealthy.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Backmerge changes from the release branch',
                type: 'AutoBackmergeReleaseBranches',
                id: 'AutoBackmergeReleaseBranches',
                stepConfigId: null,
                relevantPRs: [],

                description:
                    'Runway will backmerge changes from release branch to working branch (and any other upcoming release branches) at the end of each release cycle.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
            },
            {
                name: 'Release stable phased releases to 100% of users',
                type: 'AutoPromoteStablePhasedReleases',
                id: 'AutoPromoteStablePhasedReleases',
                stepConfigId: null,
                description:
                    'Runway will release your update to all users early if all of your defined conditions have been met, and your selected health metrics stay within your defined health threshold.',
                scheduledAt: null,
                status: 'active',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Delete version-specific release branches at the end of the release cycle',
                type: 'AutoDeleteReleaseBranch',
                id: 'AutoDeleteReleaseBranch',
                stepConfigId: null,
                description:
                    'Runway will delete version-specific release branches when the release is complete and tagged. (NOTE: This automation should only be enabled by teams that use version-specific release branches.)',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
    },
];

const baseReleaseStepsAndroid: () => RecursiveStringifyEnums<ReleaseStep[]> = () => [
    {
        type: 'kickoff',
        description: 'Kickoff',
        status: 'ready',
        statusReasonString: 'Kicked off!',
        data: generateReleaseStepKickoffData(AppPlatform.Android),
        groupIndex: 0,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'abc',
                title: 'Pre-kickoff reminders',
                description: 'Description   \u003cb\u003eyo\u003c/b\u003e !!',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-02-27T23:05:20.886428625Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                uid: 'abc',
                createdAt: '2022-02-27T23:05:20.886428625Z',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'def',
                title: 'Send out reminder for upcoming release deadlines',
                description: 'Some detail',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-03T18:03:32.236911544Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: {
                    comment: 'Reminder sent via email',
                    createdAt: '2022-03-03T18:00:32.236911544Z',
                    createdBy: 'aearhart@demo.com',
                },
                owners: [],
                uid: 'def',
                createdAt: '2022-03-03T18:00:32.236911544Z',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'jkl',
                title: 'Verify versioning with product team',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'kickoff',
                approverGroups: [],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-03T18:03:33.133516479Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                uid: 'jkl',
                createdAt: '2022-03-03T18:03:33.133516479Z',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Kick off release on target date',
                type: 'AutoKickoff',
                id: 'AutoKickoff',
                stepConfigId: null,
                description:
                    'Runway will create a release branch off of your working branch for the next release on the scheduled date.',
                scheduledAt: '2022-04-15T15:00:00Z',
                status: 'inactive',
                statusMessage: 'Requires Version Control integration to be installed.',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: true,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Trigger workflow after release kickoff',
                type: 'AutoKickoffTriggerWorkflow',
                id: 'AutoKickoffTriggerWorkflow',
                stepConfigId: null,

                description: 'Runway will trigger the configured CI build workflow after release is kicked off.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: 'Auto trigger workflow is not enabled',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create and sync Play Console versions as needed to match current Runway release',
                type: 'AutoCreateAppStoreVersions',
                id: 'AutoCreateAppStoreVersions',
                stepConfigId: null,
                description:
                    'Runway will create a draft production release in the Play Console for the current release in Runway if needed, and keep the version name in sync if the version changes in Runway.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create upcoming version in Runway when current release is kicked off',
                type: 'AutoCreateRunwayReleases',
                id: 'AutoCreateRunwayReleases',
                stepConfigId: null,
                description:
                    'Runway will create a new release record for your next version when your current release is kicked off. This will assign a release pilot and provide a selectable upcoming release via the versions timeline in App Home.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Merge pull requests opened by Runway',
                type: 'AutoMergeRunwayPRs',
                id: 'AutoMergeRunwayPRs',
                stepConfigId: null,
                description:
                    'Runway creates pull requests to fulfill certain tasks (e.g. bumping version in code). If enabled, Runway will attempt to merge these PRs automatically, once any status checks or approvals are satisfied.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: 'Requires Version Control integration to be installed.',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Create release-specific Slack channel(s)',
                type: 'AutoCreateReleaseChannels',
                id: 'AutoCreateReleaseChannels',
                stepConfigId: null,
                description:
                    'Runway will automatically create new Slack channel(s) for the release, if you have any release-specific channels configured (e.g. release-{version}) in settings.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'featureReadiness',
        description: 'Feature readiness',
        status: 'pending',
        statusReasonString: 'Some work for this release is not yet complete.',
        data: featuresStep(AppPlatform.Android),
        groupIndex: 0,
        orderIndex: 1,
        checklistItems: [
            {
                id: 'abc',
                title: 'Verify production feature flags are correct for this release',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'featureReadiness',
                approverGroups: ['engineer'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-15T22:54:38.462070296Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                uid: 'abc',
                createdAt: '2022-03-15T22:54:38.462070296Z',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'def',
                title: 'Update CMS version flags for this release',
                description: '',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'featureReadiness',
                approverGroups: [],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: {
                    status: 'approved',
                    createdAt: '2022-03-15T22:54:39.472656772Z',
                    createdBy: 'aearhart@demo.com',
                },
                comment: null,
                owners: [],
                uid: 'def',
                createdAt: '2022-03-15T22:54:39.472656772Z',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Add appropriate labels and/or fix versions when they are missing from tickets',
                type: 'AutoAddMissingFAs',
                id: 'AutoAddMissingFAs',
                stepConfigId: null,
                description:
                    'Runway will add appropriate labels and/or fix versions when they are missing from tickets that are associated with the release. These label and fix version patterns are defined in App Settings.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: 'You have no label or fix version patterns set in feature affiliations settings.',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'translations',
        description: 'Translations',
        status: 'pending',
        statusReasonString: 'Waiting for translations from Crowdin',
        data: {
            isApproved: false,
            ...translationData,
            keys: Object.values(translationData.byKey),
            workingBranchKeys: Object.values(translationData.workingBranchStrings),
        },
        groupIndex: 0,
        orderIndex: 2,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Update translations on the release branch from the working branch',
                type: 'AutoCherryPickLocalizableStrings',
                id: 'AutoCherryPickLocalizableStrings',
                stepConfigId: null,
                description:
                    'Runway will update translations on the release branch by pulling over new translations from the working branch as needed.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                hasEditableSettings: true,
                relevantPRs: [],
            },
            {
                name: 'Sync metadata translations',
                type: 'AutoSyncMetadataTranslations',
                id: 'AutoSyncMetadataTranslations',
                stepConfigId: null,
                description:
                    'Runway will upload release metadata for translation if needed and export translated metadata to Play Console when ready.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                hasEditableSettings: true,
                relevantPRs: [],
            },
            {
                name: 'Sync localizable string translations',
                type: 'AutoSyncTranslations',
                id: 'AutoSyncTranslations',
                stepConfigId: null,
                description:
                    'Runway will upload new or updated strings for translation as needed, and export strings from the provider and open a pull request when ready.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                hasEditableSettings: true,
                relevantPRs: [],
            },
        ],
        blockingConfig: 'Blocking',
        id: '',
    },
    {
        type: 'releaseCandidate',
        description: 'CI',
        status: 'ready',
        statusReasonString: 'CI build is ready!',
        data: {
            builds: [
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: { status: 'completed', userFraction: 0 },
                        buildNumber: '27500',
                        id: '27500',
                        integrationId: 'google-beta',
                        isProcessed: true,
                        status: 'completed',
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T18:11:14.055381Z',
                        userFraction: 0,
                    },
                    ciBuild: {
                        artifacts: [
                            {
                                appStoreInfos: {
                                    'apple-beta:12345': {
                                        ascTransactionId: null,
                                        createdAt: '2024-06-18T13:23:42.206312351Z',
                                        destinationInstallationId: 'apple-beta:12345',
                                        errorMessage: null,
                                        trackName: 'internal',
                                        uploadCompletedAt: '2024-06-18T13:24:46.121413185Z',
                                        uploadRetryCount: 1,
                                        uploadStatus: 'success',
                                    },
                                },
                                artifactId: 'com.example.demo(27500)-demo-release.aab-9565450180',
                                binaryBuildDetails: {
                                    appName: 'com.example.demo',
                                    artifactType: 'BuildArtifactAndroidAAB',
                                    buildIdentifier: '27500',
                                    bundleName: 'com.example.demo',
                                    provisioningProfile: null,
                                    versionString: '1.1.0',
                                },
                                downloadUrl:
                                    'https://demo.runway.team/api/org/demo/app/appollo/release/appollo-android:1.1.0/artifact?artifactId=3f686ac9386fd0aa\\u0026buildId=555600c7-de5c-4829-b267-f19ac3b13ae9',
                                dsymUploadInfo: null,
                                fileName: 'com.example.demo(27500)-demo-release.aab',
                                size: 86,
                                version: '1.1.0',
                                workflowRunId: '9565450180',
                            },
                        ],
                        branch: 'release-1.25.0',
                        buildFinishedAt: '2022-03-15T18:09:36Z',
                        buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                        buildIdentifier: '275',
                        buildStartedAt: '2022-03-15T18:06:21Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitAuthor: 'runwayhelperdev[bot]',
                        commitMessage:
                            'Bumping version (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '1234',
                    },
                    isSelectedBuild: true,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: { status: null, userFraction: 0 },
                        buildNumber: '27100',
                        id: '27100',
                        integrationId: 'google-beta',
                        isProcessed: true,
                        status: null,
                        type: 'android-aab',
                        uploadedAt: '2022-03-15T15:53:26.217791Z',
                        userFraction: 0,
                    },
                    ciBuild: {
                        artifacts: [],
                        branch: 'release-1.25.0',
                        buildFinishedAt: '2022-03-15T15:53:31Z',
                        buildHash: 'abc',
                        buildIdentifier: '271',
                        buildStartedAt: '2022-03-15T15:50:06Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitAuthor: 'runwayhelperdev[bot]',
                        commitMessage:
                            'Bumping version (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '1234',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: { status: null, userFraction: 0 },
                        buildNumber: '26600',
                        id: '26600',
                        integrationId: 'google-beta',
                        isProcessed: true,
                        status: null,
                        type: 'android-aab',
                        uploadedAt: '2022-02-22T15:10:44.431772-06:00',
                        userFraction: 0,
                    },
                    ciBuild: {
                        artifacts: [],
                        branch: 'release-1.25.0',
                        buildFinishedAt: '2022-02-22T21:09:21Z',
                        buildHash: 'xIF7XbFDz_ILtKZjP3TOnVythwo=',
                        buildIdentifier: '266',
                        buildStartedAt: '2022-02-22T21:05:24Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/339716b3-ad88-417a-a16c-6b291ed196db',
                        commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                        commitAuthor: 'runwayhelperdev[bot]',
                        commitMessage:
                            'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '339716b3-ad88-417a-a16c-6b291ed196db',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    associatedAppStoreBuild: {
                        betaBuildDetails: { status: null, userFraction: 0 },
                        buildNumber: '26300',
                        id: '26300',
                        integrationId: 'google-beta',
                        isProcessed: true,
                        status: null,
                        type: 'android-aab',
                        uploadedAt: '2022-02-14T18:29:27.228176572Z',
                        userFraction: 0,
                    },
                    ciBuild: {
                        artifacts: [],
                        branch: 'release-1.25.0',
                        buildFinishedAt: '2022-02-14T18:29:57Z',
                        buildHash: 'EoC1sXC38yCv2FysjX3xoT8joUE=',
                        buildIdentifier: '263',
                        buildStartedAt: '2022-02-14T18:26:48Z',
                        buildStatus: 'success',
                        buildUrl: 'https://app.bitrise.io/build/c8bc9aa2-864f-46a0-99c8-c38fff620763',
                        commit: '2a9abf9fb4eb2355dfd1600b622ea4f63ee4405d',
                        commitAuthor: null,
                        commitMessage:
                            'Bumping version to 1.24.0 (#40)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                        integrationId: 'bitrise',
                        providerBuildStatusString: 'Success',
                        workflowRunId: 'c8bc9aa2-864f-46a0-99c8-c38fff620763',
                    },
                    isSelectedBuild: false,
                    selectedReason: 'autoRunwaySelection',
                },
            ],
            workflowData: {
                branch: 'release-1.25.0',
                headCommit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                headCommitAuthor: 'runwayhelperdev[bot]',
                headCommitMessage:
                    'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                integrationType: 'bitrise',
                workflowName: 'release',
                workflowType: 'staging',
                workflowUrl:
                    'https://app.bitrise.io/app/d09c63f8c17bb806/workflow_editor#!/workflows?workflow_id=release',
            },
        },
        groupIndex: 1,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Enable artifact downloads',
                type: 'AutoDownloadArtifacts',
                id: 'AutoDownloadArtifacts',
                stepConfigId: null,
                description:
                    'Runway will download all artifacts generated from your build workflow and provide direct download links to them from the Runway interface. Additionally, Runway will include artifact information in Slack build success notifications, including a link to find those downloads in Runway.',
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'regressionTesting',
        description: 'Regression testing',
        status: 'pending',
        statusReasonString: 'Regression testing in progress...',
        data: {
            availableBuilds: [
                {
                    appStoreBuildIdentifier: '27500',
                    appStoreIntegrationId: 'google',
                    buildIdentifier: '275',
                    hash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '27100',
                    appStoreIntegrationId: 'google',
                    buildIdentifier: '271',
                    hash: 'v_LYY2Q_tHP__uFMuoahvSvrjbs=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '26600',
                    appStoreIntegrationId: 'google',
                    buildIdentifier: '266',
                    hash: 'xIF7XbFDz_ILtKZjP3TOnVythwo=',
                    integrationId: 'bitrise',
                },
                {
                    appStoreBuildIdentifier: '26300',
                    appStoreIntegrationId: 'google',
                    buildIdentifier: '263',
                    hash: 'EoC1sXC38yCv2FysjX3xoT8joUE=',
                    integrationId: 'bitrise',
                },
            ],
            regressionBuildInfo: {
                associatedAppStoreBuild: {
                    betaBuildDetails: { status: 'completed', userFraction: 0 },
                    buildNumber: '27500',
                    id: '27500',
                    integrationId: 'google-beta',
                    isProcessed: true,
                    status: 'completed',
                    type: 'android-aab',
                    uploadedAt: '2022-03-15T18:11:14.055381Z',
                    userFraction: 0,
                },
                ciBuild: {
                    artifacts: null,
                    branch: 'release-1.25.0',
                    buildFinishedAt: '2022-03-15T18:09:36Z',
                    buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                    buildIdentifier: '275',
                    buildStartedAt: '2022-03-15T18:06:21Z',
                    buildStatus: 'success',
                    buildUrl: 'https://app.bitrise.io/build/bc829153-e305-4058-bf4c-9f9d04fae7a9',
                    commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                    commitAuthor: 'runwayhelperdev[bot]',
                    commitMessage:
                        'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                    integrationId: 'bitrise',
                    providerBuildStatusString: 'Success',
                    workflowRunId: 'bc829153-e305-4058-bf4c-9f9d04fae7a9',
                },
            },
            status: 'inProgress',
            testItems: [
                {
                    approverGroups: ['pilot'],
                    comment: null,
                    description: 'And make sure to do it in an efficient way',
                    id: 'c4tuob32dnc706n8d30g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Run full checkout flow',
                    type: 'multi',
                    owners: ['ssullenberger@demo.com'],
                },
            ],
            nonHistoricalTestRunsCompletionFraction: 0.95,
            nonHistoricalTestRunsStatusesTotalCount: 30,
            testRuns: [
                {
                    completedAt: null,
                    completedCount: 10,
                    createdAt: '2022-02-17T23:48:12Z',
                    description: '',
                    id: '1',
                    integrationId: 'testrail',
                    isInProgress: true,
                    name: 'Test run',
                    statuses: [
                        { color: '6EC78B', count: 10, displayableName: 'Passed', fraction: 1 },
                        { color: '595959', count: 1, displayableName: 'Blocked', fraction: 0 },
                        { color: 'F5F5F5', count: 5, displayableName: 'Untested', fraction: 0 },
                        { color: 'F4AD22', count: 1, displayableName: 'Retest', fraction: 0 },
                        { color: 'EF2D56', count: 1, displayableName: 'Failed', fraction: 0 },
                    ],
                    totalCount: 18,
                    updatedAt: '2022-02-17T23:52:10Z',
                    url: 'https://demo.testrail.io',
                    completionFraction: 0.55,
                },
            ],
            updatedAt: '2022-03-23T20:27:22.163903405Z',
        },
        groupIndex: 1,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'betaTesting',
        description: 'Beta testing',
        status: 'pending',
        statusReasonString: 'Beta soak in progress. Waiting for manual approval.',
        data: {
            betaBuilds: [
                {
                    betaGroups: [],
                    betaStatus: 'testing',
                    betaTesters: [],
                    betaTestingNotes: [
                        {
                            displayLocale: 'American English',
                            id: '1.25.0:en-US',
                            locale: 'en-US',
                            notes: 'Preparing to release redesign of product page, redesign of checkout.',
                        },
                        {
                            displayLocale: 'Australian English',
                            id: '1.25.0:en-AU',
                            locale: 'en-AU',
                            notes: 'Preparing to release redesign of product page, redesign of checkout.',
                        },
                        {
                            displayLocale: 'Latin American Spanish',
                            id: '1.25.0:es-419',
                            locale: 'es-419',
                            notes: 'Preparing to release redesign of product page, redesign of checkout.',
                        },
                        {
                            displayLocale: 'European Spanish',
                            id: '1.25.0:es-ES',
                            locale: 'es-ES',
                            notes: 'Preparing to release redesign of product page, redesign of checkout.',
                        },
                    ],
                    buildId: '27500',
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '27500',
                            id: '27500',
                            integrationId: 'google-beta',
                            isProcessed: true,
                            status: 'completed',
                            type: 'android-aab',
                            uploadedAt: '2022-03-15T18:11:14.055381Z',
                        },
                        associatedCIBuild: {
                            branch: 'release-1.25.0',
                            buildFinishedAt: '2022-03-15T18:09:36Z',
                            buildHash: '5dGgafjgm3ECgAvSmUmyok8bFZY=',
                            buildIdentifier: '275',
                            buildStartedAt: '2022-03-15T18:06:21Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io/build/123',
                            commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                            commitAuthor: null,
                            commitMessage:
                                'Bumping version (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: 'bc829153-e305-4058-bf4c-9f9d04fae7a9',
                        },
                        stabilityInfo: null,
                    },
                    betaBuildDetails: { status: 'completed', userFraction: 0 },
                    isConsideredExternal: false,
                    isLatestBuild: true,
                    isSelectedBuild: true,
                    metrics: { numInstalls: 0 },
                    selectedReason: 'autoRunwaySelection',
                },
                {
                    betaGroups: [],
                    betaStatus: 'not-testing',
                    betaTesters: [],
                    betaTestingNotes: null,
                    buildId: '27100',
                    appStoreBuild: {
                        associatedCIBuild: {
                            branch: 'release-1.25.0',
                            buildFinishedAt: '2022-03-15T15:53:31Z',
                            buildHash: 'v_LYY2Q_tHP__uFMuoahvSvrjbs=',
                            buildIdentifier: '271',
                            buildStartedAt: '2022-03-15T15:50:06Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io',
                            commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                            commitAuthor: null,
                            commitMessage:
                                'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '459e9bfc-b185-4acf-b95f-caa50d70da40',
                        },
                        appStoreBuild: {
                            buildNumber: '27100',
                            id: '27100',
                            integrationId: 'google-beta',
                            isProcessed: true,
                            status: null,
                            type: 'android-aab',
                            uploadedAt: '2022-03-15T15:53:26.217791Z',
                        },
                        stabilityInfo: null,
                    },
                    betaBuildDetails: { status: null, userFraction: 0 },
                    isConsideredExternal: false,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
                {
                    betaGroups: [],
                    betaStatus: 'not-testing',
                    betaTesters: [],
                    betaTestingNotes: null,
                    buildId: '26600',
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '26600',
                            id: '26600',
                            integrationId: 'google-beta',
                            isProcessed: true,
                            status: null,
                            type: 'android-aab',
                            uploadedAt: '2022-02-22T15:10:44.431772-06:00',
                        },
                        associatedCIBuild: {
                            branch: 'release-1.25.0',
                            buildFinishedAt: '2022-02-22T21:09:21Z',
                            buildHash: 'xIF7XbFDz_ILtKZjP3TOnVythwo=',
                            buildIdentifier: '266',
                            buildStartedAt: '2022-02-22T21:05:24Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io',
                            commit: '8377f75e11ef0544ac5d7b138f8ec1af913203be',
                            commitAuthor: null,
                            commitMessage:
                                'Bumping version to 1.25.0 (#41)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: '339716b3-ad88-417a-a16c-6b291ed196db',
                        },
                        stabilityInfo: null,
                    },
                    betaBuildDetails: { status: null, userFraction: 0 },
                    isConsideredExternal: false,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
                {
                    betaGroups: [],
                    betaStatus: 'not-testing',
                    betaTesters: [],
                    betaTestingNotes: null,
                    buildId: '26300',
                    appStoreBuild: {
                        appStoreBuild: {
                            buildNumber: '26300',
                            id: '26300',
                            integrationId: 'google-beta',
                            isProcessed: true,
                            status: null,
                            type: 'android-aab',
                            uploadedAt: '2022-02-14T18:29:27.228176572Z',
                        },
                        associatedCIBuild: {
                            branch: 'release-1.25.0',
                            buildFinishedAt: '2022-02-14T18:29:57Z',
                            buildHash: 'EoC1sXC38yCv2FysjX3xoT8joUE=',
                            buildIdentifier: '263',
                            buildStartedAt: '2022-02-14T18:26:48Z',
                            buildStatus: 'success',
                            buildUrl: 'https://app.bitrise.io',
                            commit: '2a9abf9fb4eb2355dfd1600b622ea4f63ee4405d',
                            commitAuthor: null,
                            commitMessage:
                                'Bumping version to 1.24.0 (#40)\n\nCo-authored-by: runwayhelperdev[bot] \u003c68658124+runwayhelperdev[bot]@users.noreply.github.com\u003e',
                            integrationId: 'bitrise',
                            providerBuildStatusString: 'Success',
                            workflowRunId: 'c8bc9aa2-864f-46a0-99c8-c38fff620763',
                        },
                        stabilityInfo: null,
                    },
                    betaBuildDetails: { status: null, userFraction: 0 },
                    isConsideredExternal: false,
                    isLatestBuild: false,
                    isSelectedBuild: false,
                    metrics: { numInstalls: 0 },
                    selectedReason: '',
                },
            ],
            betaGroups: [
                {
                    id: 'windock-testing-group@googlegroups.com',
                    isExternalGroup: true,
                    name: 'windock-testing-group@googlegroups.com',
                    testers: [],
                },
            ],
            soakDidFinishEarly: false,
            soakFinishedAt: null,
            soakStartedAt: '2022-03-15T18:11:14.055381Z',
            testers: null,
        },
        groupIndex: 1,
        orderIndex: 2,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Promote builds to testing track',
                type: 'AutoPromoteBuildsToTestTrack',
                id: 'AutoPromoteBuildsToTestTrack',
                stepConfigId: null,
                description:
                    'Runway will promote any newly uploaded APKs/AABs to your testing track and start the rollout.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Apply beta testing notes to new beta builds',
                type: 'AutoApplyBetaBuildNotes',
                id: 'AutoApplyBetaBuildNotes',
                stepConfigId: null,
                description:
                    'Runway will automatically carry over the beta release notes of the previous build to new beta builds.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'screenshots',
        description: 'Screenshots',
        status: 'pending',
        statusReasonString: 'Approval required.',
        data: {
            isApproved: false,
            requiresApproval: true,
            platform: 'android',
            appStoreType: 'google',
            screenshotLocalizations: [
                {
                    displayLocale: 'American English',
                    locale: 'en-US',
                    screenshotSets: [
                        {
                            screenshotDisplayType: 'phoneScreenshots',
                            screenshots: [
                                {
                                    height: 1562,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-Android-1.png',
                                    width: 2778,
                                },
                                {
                                    height: 1562,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-Android-2.png',
                                    width: 2778,
                                },
                            ],
                        },
                    ],
                },
                {
                    displayLocale: 'European Spanish',
                    locale: 'es-ES',
                    screenshotSets: [
                        {
                            screenshotDisplayType: 'phoneScreenshots',
                            screenshots: [
                                {
                                    height: 1562,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-Android-1.png',
                                    width: 2778,
                                },
                                {
                                    height: 1562,
                                    url: 'https://runway-img.s3.us-east-2.amazonaws.com/demo-app-Android-2.png',
                                    width: 2778,
                                },
                            ],
                        },
                    ],
                },
            ],
            storeUrl: 'https://play.google.com/console',
        },
        groupIndex: 2,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'c03218kcu89v1j3i28cg',
                title: 'Upload screenshots to Google play per the guidelines',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'screenshots',
                approverGroups: ['design'],
                releaseTypes: 'all',
                notifyEnabled: false,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'metadata',
        description: 'Metadata',
        status: 'pending',
        statusReasonString: 'Waiting for manual approval',
        data: generateReleaseStepMetadataData(AppPlatform.Android),
        groupIndex: 2,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Apply release notes to new versions in Play Console',
                type: 'AutoApplyMetadata',
                id: 'AutoApplyMetadata',
                stepConfigId: null,
                description:
                    'Runway will apply release notes to new versions created in the Play Console. You can make updates to the text as needed before you submit your update for review.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'approvals',
        description: 'Approvals',
        status: 'pending',
        statusReasonString: 'There are 2 items that still require approval.',
        data: {
            approvalItems: [
                {
                    approverGroups: ['pm'],
                    comment: null,
                    description: null,
                    id: 'c8to4mu9f6i9qtljdkjg',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        createdAt: '2022-03-23T20:26:38.120635796Z',
                        createdBy: 'aearhart@demo.com',
                        status: 'approved',
                    },
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Approval from Engagement team',
                    type: 'multi',
                    owners: ['aearhart@demo.com'],
                },
                {
                    approverGroups: ['engineer'],
                    comment: null,
                    description: null,
                    id: 'c8to4q69f6i9qtljdkk0',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Approval from Acquisitions team',
                    type: 'multi',
                    owners: ['narmstrong@demo.com', 'ssullenberger@demo.com'],
                },
                {
                    approverGroups: ['pm'],
                    comment: null,
                    description: null,
                    id: 'c8to4t69f6i9qtljdkkg',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Approval from Payments team',
                    type: 'multi',
                    owners: [],
                },
            ],
        },
        groupIndex: 3,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'submission',
        description: 'Submission',
        status: 'pending',
        statusReasonString: 'Ready to submit.',
        data: generateReleaseStepSubmissionData(AppPlatform.Android),
        groupIndex: 4,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'c5n2h7ln86bo9gnibnr0',
                title: 'Thing to do before submit',
                description: 'Do this!',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['approver'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'c8al5bdn86bs44bjrpd0',
                title: 'Another thing to remember before submitting',
                description: 'All this stuff',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['pilot', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'c8e0r55n86boufv00ong',
                title: 'Important Pre-submit step',
                description: 'Remember to do this before submitting.',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'submission',
                approverGroups: ['pilot', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: false,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Submit app for review',
                type: 'AutoSubmit',
                id: 'AutoSubmit',
                stepConfigId: null,
                description:
                    'Runway will submit your selected build for review on the scheduled date if all previous steps are ready (green).',
                scheduledAt: '2022-04-18T15:00:00Z',
                status: 'inactive',
                statusMessage: 'Requires app store integration to be installed.',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: true,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Add APK/AAB to the production track',
                type: 'AutoSelectLatestBuild',
                id: 'AutoSelectLatestBuild',
                stepConfigId: null,
                description:
                    'Runway will select the latest available APK/AAB in the production track in the Play Console.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'storeReview',
        description: 'App store review',
        status: 'inactive',
        statusReasonString: 'Waiting for submission.',
        data: generateReleaseStepStoreReviewData(AppPlatform.Android),
        groupIndex: 4,
        orderIndex: 1,
        checklistItems: [
            {
                id: 'c7oomvdn86bpp9lejr1g',
                title: 'Release via managed publishing if needed',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'storeReview',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
            {
                id: 'c59kpldachdcretdibcg',
                title: 'Many different users can deal with this',
                description: 'engineers, qa and pms should be able to approve this',
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'storeReview',
                approverGroups: ['engineer', 'qa', 'pm'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'takeoff',
        description: 'Release',
        status: 'inactive',
        statusReasonString: 'Waiting for submission.',
        data: generateReleaseStepTakeoffData(AppPlatform.Android),
        groupIndex: 4,
        orderIndex: 2,
        checklistItems: [
            {
                id: 'bvv18nkfoo7cohhp7ju0',
                title: 'Send announcement email to team@ distribution list',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'takeoff',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [
            {
                name: 'Tag releases at the end of the release cycle',
                type: 'AutoTagReleases',
                id: 'AutoTagReleases',
                stepConfigId: null,
                description:
                    'Runway will tag your production release commit at the end of each release cycle, and generate a summary of all work going out with the release.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: 'Requires Version Control integration to be installed.',
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Halt unstable phased releases',
                type: 'AutoHaltUnstablePhasedReleases',
                id: 'AutoHaltUnstablePhasedReleases',
                stepConfigId: null,
                description:
                    'Runway will halt your staged rollout if all of your defined conditions have been met, and any of your selected health metrics become unhealthy.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Backmerge changes from the release branch',
                type: 'AutoBackmergeReleaseBranches',
                id: 'AutoBackmergeReleaseBranches',
                stepConfigId: null,
                description:
                    'Runway will backmerge changes from release branch to working branch (and any other upcoming release branches) at the end of each release cycle.',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Release stable phased releases to 100% of users',
                type: 'AutoPromoteStablePhasedReleases',
                id: 'AutoPromoteStablePhasedReleases',
                stepConfigId: null,
                description:
                    'Runway will roll out your update to all users early if all of your defined conditions have been met, and your selected health metrics stay within your defined health threshold',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
            {
                name: 'Delete version-specific release branches at the end of the release cycle',
                type: 'AutoDeleteReleaseBranch',
                id: 'AutoDeleteReleaseBranch',
                stepConfigId: null,
                description:
                    'Runway will delete version-specific release branches when the release is complete and tagged. (NOTE: This automation should only be enabled by teams that use version-specific release branches.)',
                scheduledAt: null,
                status: 'inactive',
                statusMessage: null,
                statusMessageLinkUrl: null,

                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
];

const baseReleaseStepsOTA: () => RecursiveStringifyEnums<ReleaseStep[]> = () => [
    {
        type: 'kickoff',
        description: 'Kickoff',
        status: 'ready',
        statusReasonString: 'Kicked off!',
        data: generateReleaseStepKickoffData(AppPlatform.ReactNativeOTA),
        groupIndex: 0,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Kick off release on target date',
                type: 'AutoKickoff',
                id: 'AutoKickoff',
                stepConfigId: null,
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: true,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
            {
                name: 'Create upcoming version in Runway when current release is kicked off',
                type: 'AutoCreateRunwayReleases',
                id: 'AutoCreateRunwayReleases',
                stepConfigId: null,
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
            {
                name: 'Merge pull requests opened by Runway',
                type: 'AutoMergeRunwayPRs',
                id: 'AutoMergeRunwayPRs',
                stepConfigId: null,
                scheduledAt: null,
                status: 'active',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
            {
                name: 'Create release-specific Slack channel(s)',
                type: 'AutoCreateReleaseChannels',
                id: 'AutoCreateReleaseChannels',
                stepConfigId: null,
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'featureReadiness',
        description: 'Feature readiness',
        status: 'ready',
        statusReasonString: 'All work for this release is complete!',
        data: featuresStep(AppPlatform.ReactNativeOTA),
        groupIndex: 0,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Add appropriate labels and/or fix versions when they are missing from tickets',
                type: 'AutoAddMissingFAs',
                id: 'AutoAddMissingFAs',
                stepConfigId: null,
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'releaseCandidate',
        description: 'Staging release',
        status: 'ready',
        statusReasonString: 'Staging release is complete.',
        data: {
            builds: [
                {
                    associatedAppStoreBuild: null,
                    ciBuild: {
                        artifacts: [],
                        branch: '',
                        buildFinishedAt: '2022-02-22T15:19:47Z',
                        buildHash: 'abc123',
                        buildIdentifier: '15',
                        buildStartedAt: '2022-02-22T15:17:12Z',
                        buildStatus: 'success',
                        buildUrl: 'https://github.com/demo/fake-react-native/actions/runs/123',
                        commit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                        commitAuthor: 'Amelia Earhart',
                        commitMessage:
                            'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                        integrationId: 'github-ci',
                        providerBuildStatusString: 'Success',
                        workflowRunId: '123',
                    },
                    isSelectedBuild: true,
                    selectedReason: 'autoRunwaySelection',
                },
            ],
            workflowData: {
                branch: 'release-codepush-1.3.0',
                headCommit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                headCommitAuthor: 'aearhart',
                headCommitMessage:
                    'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                integrationType: 'github-ci',
                workflowName: 'Release CodePush Staging',
                workflowType: 'staging',
                workflowUrl: 'https://github.com/demo/fake-react-native/blob/master/.github/workflows/node.js.yml',
            },
        },
        groupIndex: 1,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [
            {
                name: 'Enable artifact downloads',
                type: 'AutoDownloadArtifacts',
                id: 'AutoDownloadArtifacts',
                stepConfigId: null,
                scheduledAt: null,
                status: 'inactive',
                isPartOfSequence: false,
                sequenceNumber: null,
                isLifecycle: false,
                autoScheduledFromCadence: null,
                description: '',
                relevantPRs: [],
            },
        ],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'regressionTesting',
        description: 'Regression testing',
        status: 'pending',
        statusReasonString: 'Regression testing in progress...',
        data: {
            availableBuilds: [
                {
                    appStoreBuildIdentifier: null,
                    appStoreIntegrationId: null,
                    buildIdentifier: '15',
                    hash: 'fIYLHm7c9r5yxKacHK9H41G7eG8=',
                    integrationId: 'github-ci',
                },
            ],
            regressionBuildInfo: {
                associatedAppStoreBuild: null,
                ciBuild: {
                    artifacts: null,
                    branch: '',
                    buildFinishedAt: '2022-02-22T15:19:47Z',
                    buildHash: 'fIYLHm7c9r5yxKacHK9H41G7eG8=',
                    buildIdentifier: '15',
                    buildStartedAt: '2022-02-22T15:17:12Z',
                    buildStatus: 'success',
                    buildUrl: 'https://github.com/demo/fake-react-native/actions/runs/12345678',
                    commit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                    commitAuthor: 'Amelia Earhart',
                    commitMessage:
                        'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                    integrationId: 'github-ci',
                    providerBuildStatusString: 'Success',
                    workflowRunId: '12345678',
                },
            },
            status: 'inProgress',
            testItems: [
                {
                    approverGroups: ['qa'],
                    comment: {
                        comment: 'Tested sign in with google, github, apple, all look good',
                        createdAt: '2022-02-27T23:00:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    description: null,
                    id: 'c55n1kdachdaceuvmb00',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'passed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test login flow',
                    type: 'multi',
                    owners: ['ssullenberger@demo.com'],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c8kfkuln86busgdit4ag',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'inProgress',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test "Add receipts" flow',
                    type: 'multi',
                    owners: ['narmstrong@demo.com'],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c55n1p5achdaceuvmb0g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'passed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test checkout flow',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c55n25lachdaceuvmb1g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Test "Share with friends" flow',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: 'Remember to test this stuff right now',
                    id: 'c8efiddn86bppsoltosg',
                    notifyEnabled: false,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'failed',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'failed', 'passed'],
                    title: 'Another thing to test',
                    type: 'multi',
                    owners: [],
                },
            ],
            testRuns: [],
            updatedAt: '2022-03-22T19:55:19.140298-04:00',
        },
        groupIndex: 1,
        orderIndex: 1,
        checklistItems: [],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'betaTesting',
        description: 'Beta testing',
        status: 'ready',
        statusReasonString: 'Beta testing completed!',
        data: {
            betaBuilds: null,
            betaGroups: null,
            buildInfo: {
                associatedAppStoreBuild: null,
                ciBuild: {
                    artifacts: [],
                    branch: '',
                    buildFinishedAt: '2022-02-22T15:19:47Z',
                    buildHash: 'fIYLHm7c9r5yxKacHK9H41G7eG8=',
                    buildIdentifier: '15',
                    buildStartedAt: '2022-02-22T15:17:12Z',
                    buildStatus: 'success',
                    buildUrl: 'https://github.com/demo/fake-react-native/actions/runs/12345678',
                    commit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                    commitAuthor: 'Amelia Earhart',
                    commitMessage:
                        'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                    integrationId: 'github-ci',
                    providerBuildStatusString: 'Success',
                    workflowRunId: '12345678',
                },
                isSelectedBuild: true,
                selectedReason: 'autoRunwaySelection',
            },
            soakDidFinishEarly: true,
            soakFinishedAt: '2022-02-23T15:19:47Z',
            soakStartedAt: '2022-02-22T15:19:47Z',
            testers: null,
        },
        groupIndex: 1,
        orderIndex: 2,
        checklistItems: [],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'approvals',
        description: 'Approvals',
        status: 'pending',
        statusReasonString: 'There are 3 items that still require approval.',
        data: {
            approvalItems: [
                {
                    approverGroups: ['qa'],
                    comment: null,
                    description: null,
                    id: 'c51sfnlachdb4vli3720',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'approved',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'ssullenberger@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Mobile - Checkout',
                    type: 'multi',
                    owners: ['ssullenberger@demo.com'],
                },
                {
                    approverGroups: [],
                    comment: {
                        comment: 'Verified on latest, no issues',
                        createdBy: 'aearhart@demo.com',
                        createdAt: '2022-02-27T23:00:20.886428625Z',
                    },
                    description: null,
                    id: 'c51p2qdachdas7jctn8g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: {
                        status: 'approved',
                        createdAt: '2022-02-27T23:05:20.886428625Z',
                        createdBy: 'aearhart@demo.com',
                    },
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Security/Ops',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['engineer'],
                    comment: null,
                    description: null,
                    id: 'c51p10dachdas7jctn6g',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Mobile - Core',
                    type: 'multi',
                    owners: ['narmstrong@demo.com', 'ssullenberger@demo.com'],
                },
                {
                    approverGroups: ['marketing'],
                    comment: null,
                    description: null,
                    id: 'c55mpltachdaceuvmaug',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Sign-off from marketing',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['pilot'],
                    comment: null,
                    description: null,
                    id: 'c51sif8m221m3fc0c4hg',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Get signoff from security/infra',
                    type: 'multi',
                    owners: [],
                },
                {
                    approverGroups: ['pilot'],
                    comment: null,
                    description: null,
                    id: 'c51sif8m221m3fc0c4i0',
                    notifyEnabled: true,
                    oneOffForVersion: null,
                    releaseStepType: null,
                    releaseTypes: 'all',
                    status: null,
                    statuses: ['inProgress', 'blocked', 'rejected', 'approved'],
                    title: 'Get signoff from compliance',
                    type: 'multi',
                    owners: [],
                },
            ],
        },
        groupIndex: 2,
        orderIndex: 0,
        checklistItems: [],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
    {
        type: 'ciDistribution',
        description: 'Release',
        status: 'inactive',
        statusReasonString: 'Complete all previous steps.',
        data: {
            isReleased: false,
            sdkVersion: null,
            tagData: {
                codeDiffUrl: 'https://github.com/demo/fake-react-native/compare/1.2.0...release-codepush-1.3.0',
                expectedReleaseTagName: '1.0.2',
                releaseTag: null,
                releaseTagState: 'notTaggable',
                taggableCommits: [],
            },
            workflowData: {
                branch: 'release-codepush-1.3.0',
                headCommit: '484d3fe5fc49db90faf4a97508c009480e85c397',
                headCommitAuthor: 'aearhart',
                headCommitMessage:
                    'Merge pull request #4 from demo/runway-bump-1.3.0-1645047156\n\nBumping version to 1.3.0',
                integrationType: 'github-ci',
                workflowName: 'CodePush prod deploy',
                workflowType: 'prod',
                workflowUrl: 'https://github.com/demo/fake-react-native/blob/master/.github/workflows/codepushprod.yml',
            },
        },
        groupIndex: 3,
        orderIndex: 0,
        checklistItems: [
            {
                id: 'c8t68fjin563fpmuqa60',
                title: 'Increase codepush rollout too 100% when stable',
                description: null,
                type: 'binary',
                statuses: ['approved'],
                releaseStepType: 'ciDistribution',
                approverGroups: ['pilot'],
                releaseTypes: 'all',
                notifyEnabled: true,
                oneOffForVersion: null,
                status: null,
                comment: null,
                owners: [],
                uid: '',
                createdAt: '',
                incompleteReminderEnabled: false,
                autocompleteAtTargetCompletionEnabled: false,
                includeDescriptionInNotificationsEnabled: false,
                disableReminderAfterReleaseComplete: false,
                orgTemplateId: '',
            },
        ],
        automationRuns: [],
        id: '',
        blockingConfig: 'Blocking',
    },
];

export const baseReleaseStepsForPlatform = (appPlatform: AppPlatform) => {
    return (
        appPlatform === AppPlatform.Ios ? baseReleaseStepsiOS()
        : appPlatform === AppPlatform.Android ? baseReleaseStepsAndroid()
        : appPlatform === AppPlatform.ReactNativeOTA ? baseReleaseStepsOTA()
        : null
    );
};

export const getMockedStatusReasonByArchetypeAndStatus = (
    archetype: ReleaseStepType,
    status: ReleaseStepStatus,
): string => {
    switch (archetype) {
        case ReleaseStepType.Kickoff:
            return {
                [ReleaseStepStatus.Ready]: 'Kicked off!',
                [ReleaseStepStatus.Pending]: 'Create a release branch to kick off your release.',
            }[status];
        case ReleaseStepType.FeatureReadiness:
            return {
                [ReleaseStepStatus.Ready]: 'All work for this release is complete!',
                [ReleaseStepStatus.Pending]: 'Some work for this release is not yet complete.',
            }[status];
        case ReleaseStepType.ReleaseCandidate:
            return {
                [ReleaseStepStatus.Ready]: 'CI build succeeded.',
            }[status];
        case ReleaseStepType.RegressionTesting:
            return {
                [ReleaseStepStatus.Ready]: 'Regression testing completed!',
                [ReleaseStepStatus.Pending]: 'Regression testing in progress...',
                [ReleaseStepStatus.Inactive]: 'Regression testing not started yet.',
            }[status];
        case ReleaseStepType.BetaTesting:
            return {
                [ReleaseStepStatus.Ready]: 'Beta testing completed!',
                [ReleaseStepStatus.Pending]: 'Beta soak in progress. Waiting for manual approval.',
                [ReleaseStepStatus.Inactive]: 'Waiting for beta soak to start.',
            }[status];
        case ReleaseStepType.Metadata:
            return {
                [ReleaseStepStatus.Ready]: 'Metadata is approved and ready',
                [ReleaseStepStatus.Pending]: 'Waiting for manual approval',
            }[status];
        case ReleaseStepType.Screenshots:
            return {
                [ReleaseStepStatus.Ready]: 'Screenshots are approved and ready!',
                [ReleaseStepStatus.Pending]: 'Waiting for manual approval',
            }[status];
        case ReleaseStepType.Approvals:
            return {
                [ReleaseStepStatus.Ready]: 'Step complete.',
                [ReleaseStepStatus.Pending]: 'There are items that still require approval.',
                [ReleaseStepStatus.Inactive]: 'There are items that still require approval.',
            }[status];
        case ReleaseStepType.Submission:
            return {
                [ReleaseStepStatus.Ready]: 'Your app has been submitted!',
                [ReleaseStepStatus.Pending]: 'Ready to submit',
                [ReleaseStepStatus.Inactive]:
                    'Runway will submit selected build for review if all previous steps are green.',
            }[status];
        case ReleaseStepType.StoreReview:
            return {
                [ReleaseStepStatus.Ready]: 'Your app has been approved!',
                [ReleaseStepStatus.Pending]: 'Waiting for review...',
                [ReleaseStepStatus.Inactive]: 'Waiting for submission.',
            }[status];
        case ReleaseStepType.Takeoff:
            return {
                [ReleaseStepStatus.Ready]: 'Your app has been released!',
                [ReleaseStepStatus.Pending]: 'Ready to release.',
                [ReleaseStepStatus.Inactive]: 'Waiting for review to be completed...',
            }[status];
        case ReleaseStepType.Rollout:
            return {
                [ReleaseStepStatus.Ready]: 'Your rollout is complete!',
                [ReleaseStepStatus.Inactive]: 'Waiting for release...',
            }[status];
        default:
            return '';
    }
};

export const getMockedStatusForStepRun = (
    archetype: ReleaseStepType,
    timelinePhase: ReleaseTimelinePhase,
    workflowRunStatus: ReleaseStatus,
): ReleaseStepStatus => {
    let status: ReleaseStepStatus = ReleaseStepStatus.Inactive;

    switch (timelinePhase) {
        case ReleaseTimelinePhase.Upcoming: {
            // Upcoming releases: most steps are Inactive, some early planning steps might be Pending
            status = {
                [ReleaseStepType.Kickoff]: ReleaseStepStatus.Pending,
                [ReleaseStepType.FeatureReadiness]: ReleaseStepStatus.Pending,
                [ReleaseStepType.ReleaseCandidate]: ReleaseStepStatus.Ready,
                [ReleaseStepType.Metadata]: ReleaseStepStatus.Pending,
                [ReleaseStepType.Screenshots]: ReleaseStepStatus.Pending,
            }[archetype];
            break;
        }

        case ReleaseTimelinePhase.Current: {
            status = {
                [ReleaseStepType.Kickoff]: ReleaseStepStatus.Ready,
                [ReleaseStepType.FeatureReadiness]: ReleaseStepStatus.Ready,
                [ReleaseStepType.ReleaseCandidate]: ReleaseStepStatus.Ready,
                [ReleaseStepType.RegressionTesting]: ReleaseStepStatus.Pending,
                [ReleaseStepType.BetaTesting]: ReleaseStepStatus.Pending,
                [ReleaseStepType.Metadata]: ReleaseStepStatus.Pending,
                [ReleaseStepType.Screenshots]: ReleaseStepStatus.Pending,
                [ReleaseStepType.Approvals]: ReleaseStepStatus.Ready,
                [ReleaseStepType.Submission]: ReleaseStepStatus.Pending,
            }[archetype];
            break;
        }

        case ReleaseTimelinePhase.Completed: {
            const isSkipped = workflowRunStatus === ReleaseStatus.Skipped;
            status = {
                [ReleaseStepType.Kickoff]: ReleaseStepStatus.Ready,
                [ReleaseStepType.FeatureReadiness]: ReleaseStepStatus.Ready,
                [ReleaseStepType.ReleaseCandidate]: ReleaseStepStatus.Ready,
                [ReleaseStepType.RegressionTesting]: ReleaseStepStatus.Ready,
                [ReleaseStepType.BetaTesting]: ReleaseStepStatus.Ready,
                [ReleaseStepType.Metadata]: ReleaseStepStatus.Ready,
                [ReleaseStepType.Screenshots]: ReleaseStepStatus.Ready,
                [ReleaseStepType.Approvals]: isSkipped ? ReleaseStepStatus.Inactive : ReleaseStepStatus.Ready,
                [ReleaseStepType.Submission]: isSkipped ? ReleaseStepStatus.Inactive : ReleaseStepStatus.Ready,
                [ReleaseStepType.StoreReview]: isSkipped ? ReleaseStepStatus.Inactive : ReleaseStepStatus.Ready,
                [ReleaseStepType.Takeoff]: isSkipped ? ReleaseStepStatus.Inactive : ReleaseStepStatus.Ready,
                [ReleaseStepType.Rollout]: isSkipped ? ReleaseStepStatus.Inactive : ReleaseStepStatus.Ready,
            }[archetype];

            break;
        }
    }

    return status ?? ReleaseStepStatus.Inactive;
};
